import LiveFeedback, { useLiveNotice } from './LiveFeedback';
import { orderManagedProducts } from "../../../../Component/tool/managedProductOrder";
import { matchesProductTypo } from "../../../../Component/tool/productNameSearch";
import LiveChoiceButtons from './LiveChoiceButtons';
import AdminCancellationDialog from "../../../../Component/UI/AdminCancellationDialog";
import { getProductSaleStatus, hasProductExposure } from "../../../../Component/tool/productExposure";
import { LiveCaptureSource } from "../captureLiveImage";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useParams } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import api from "../../../../Component/axios_Interceptor/api";
import api2 from "../../../../Component/axios_Interceptor/api2";
import { Live_itemList } from "../../../../Component/Interface/Live";
import url, { SERVER_ADDRESS, SOCKET_SERVER_URL } from "../../../../Component/server";
import { fontStyles } from "../../../../Component/style/admin_font";
import io, { Socket } from "socket.io-client";
import {
  CenterView,
  AdminIcon as Icon,
  RowView,
  RowView2,
} from "../../../../Component/style/common_style";
import OptionBox from "../Modal/OptionBox";
import DetailItemInsert from "./Detail_itemInsert";
import { StoreInfo } from "../../../../Component/Interface/Store";
import ProductImageModal from "../Modal/ProductImageModal";
import ProductDescriptionModal from "../Modal/ProductDescriptionModal";
import { productRequestError } from "../productRequestError";
import { mediaUrl } from "../../../../Component/tool/mediaUrl";
import { directUploadFiles } from "../../../../Component/tool/directUpload";
import LiveDiscountCoupon from "./LiveDiscountCoupon";
import LiveToolbarIcon from "./LiveToolbarIcon";
import LiveDetailDialog from "./LiveDetailDialog";
import LoadWarehouseProductsModal from "../../ProductWarehouse/LoadWarehouseProductsModal";
import { printProductQr } from "../../ProductWarehouse/printProductQr";
import ProductCaptureModal from "../Modal/ProductCaptureModal";

const initialConsonants = "ㄱㄲㄴㄷㄸㄹㅁㅂㅃㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎ";

const matchesProductName = (name: string, search: string) => {
  const query = search.trim().toLowerCase();
  if (!query) return true;
  if (name.toLowerCase().includes(query)) return true;
  if (![...query].every(character => initialConsonants.includes(character))) return false;
  const initials = [...name].map(character => {
    const code = character.charCodeAt(0);
    return code >= 0xac00 && code <= 0xd7a3
      ? initialConsonants[Math.floor((code - 0xac00) / 588)]
      : character.toLowerCase();
  }).join("");
  return initials.includes(query);
};

const isPriceVisible = (product: Live_itemList) => hasProductExposure(product) && product.exposure_price_mode === 'visible';
const isSoldOut = (product: Live_itemList) => ['품절', '품절노출'].includes(product.product_status);

const isVisibleManagedProduct = (product: Live_itemList) => Number(product.current_cnt) > 0 || hasProductExposure(product);
const activeSalesQuantity = (product: Live_itemList) => Math.max(0,
  Number(product.active_sales_quantity ?? (Number(product.init_cnt) - Number(product.current_cnt))) || 0);
const hasRegisteredOptions = (product: Live_itemList) => product.option_check === 'y'
  && (!Array.isArray(product.unique_option1) || product.unique_option1.length > 0);
const optionStructureLocked = (product: Live_itemList) => Boolean(product.has_orders) || activeSalesQuantity(product) > 0;
const priceEditLocked = (product: Live_itemList) => activeSalesQuantity(product) > 0;
const priceLockMessage = '판매 수량이 남아 있는 상품은 가격을 수정할 수 없습니다. 전체 취소 후 다시 수정해주세요.';
const inventoryLockMessage = '판매 이력이 있는 상품은 옵션 구성을 수정할 수 없습니다. 재고 수량은 수정할 수 있습니다.';

const Detail_itemList = ({
  setChange_h,
  live_cancle_check,
  setLive_cancle_check,
  store_info,
  captureImage,
  getLiveVideo,
  captureModalOpen = false,
  captureTarget,
  onCaptureModalClose,
  canManage = true,
  canRegister = true,
  registrationDisabledReason,
  paymentMode = 'pg',
  liveSocket,
  refreshVersion,
  compact = false,
  buttonChoices = false,
  onInventoryChange,
  cancelCouponTarget,
  liveStatus,
}: {
  live_cancle_check: boolean;
  setChange_h: React.Dispatch<React.SetStateAction<number>>;
  setLive_cancle_check: React.Dispatch<React.SetStateAction<boolean>>;
  store_info: StoreInfo;
  captureImage?: () => Promise<File>;
  getLiveVideo?: () => LiveCaptureSource | null;
  captureModalOpen?: boolean;
  captureTarget?: HTMLElement | null;
  onCaptureModalClose?: () => void;
  liveStatus?: string;
  canManage?: boolean;
  canRegister?: boolean;
  registrationDisabledReason?: string;
  paymentMode?: 'pg' | 'combined' | 'bank';
  liveSocket?: Socket | null;
  refreshVersion?: number;
  compact?: boolean;
  buttonChoices?: boolean;
  rehearsal?: boolean;
  onInventoryChange?: () => void;
  cancelCouponTarget?: React.Ref<HTMLDivElement>;
}) => {
  const notifyLive = useLiveNotice();
  const { seq } = useParams();
  const [observedLiveStatus, setObservedLiveStatus] = useState('');
  const canCancelProduct = true;
  const [cancelTarget, setCancelTarget] = useState<Live_itemList | null>(null);
  const [cancelReason, setCancelReason] = useState('');
  const [cancelRequestId, setCancelRequestId] = useState('');
  const [change, setChange] = useState(0);
  const [registrationCaptureOpen, setRegistrationCaptureOpen] = useState(false);
  const updateChnage = () => setChange(previous => previous + 1);

  const [ownedSocket, setSocket] = useState<Socket | null>(null);
  const socket = liveSocket === undefined ? ownedSocket : liveSocket;
  const inventoryUpdates = useRef<Record<number, number>>({});
  const salesUpdates = useRef<Record<number, { quantity: number; hasOrders?: boolean }>>({});

  useEffect(() => {
    if (liveSocket !== undefined) return;
    let disposed = false;
    let activeSocket: Socket | null = null;

    const initSocket = async () => {
      try {
        const res = await api2.get(url.Communication_url.get_live_info, {
          params: { seq: seq },
        });
        if (!disposed) setObservedLiveStatus(res.data?.live_status || '');
        if (!disposed && res.data && res.data.channel_name) {
          const newSocket = io(SOCKET_SERVER_URL, {
            path: "/socket.io",
            transports: ["websocket"],
          });

          newSocket.on("connect", () => {
            newSocket.emit("join-channel", { channelId: res.data.channel_name });
          });

          setSocket(newSocket);
          activeSocket = newSocket;
        }
      } catch (err) {
        console.error("소켓 초기화 실패:", err);
      }
    };

    initSocket();

    return () => {
      disposed = true;
      if (activeSocket) {
        activeSocket.disconnect();
      }
    };
  }, [seq, liveSocket]);

  useEffect(() => {
    if (!socket) return;
    const updateInventory = (inventory: { productSeq: number; currentCnt: number; activeSalesQuantity?: number; hasOrders?: boolean }) => {
      if (!Number.isSafeInteger(inventory?.productSeq) || !Number.isFinite(inventory.currentCnt)) return;
      inventoryUpdates.current[inventory.productSeq] = inventory.currentCnt;
      if (Number.isFinite(inventory.activeSalesQuantity) && inventory.activeSalesQuantity! >= 0) {
        salesUpdates.current[inventory.productSeq] = { quantity: inventory.activeSalesQuantity!, hasOrders: inventory.hasOrders };
      }
      onInventoryChange?.();
      const applyInventory = (products: Live_itemList[]) => products.map(product => product.seq === inventory.productSeq
        ? { ...product, current_cnt: inventory.currentCnt,
            active_sales_quantity: inventory.activeSalesQuantity ?? Math.max(0, activeSalesQuantity(product) + Number(product.current_cnt) - inventory.currentCnt),
            has_orders: inventory.hasOrders ?? product.has_orders,
            product_status: product.product_status } : product);
      setOriginList(applyInventory);
      setItemList(applyInventory);
    };
    socket.on('Inventory Changed', updateInventory);
    return () => { socket.off('Inventory Changed', updateInventory); };
  }, [socket, onInventoryChange]);

  const emitProductExposure = async () => {
    try {
      const res = await api.get(url.Communication_url.is_visable_product, {
        params: { live_seq: seq },
      });
      if (socket) {
        if (res.data !== "상품없음") {
          socket.emit("Stock Over", res.data);
        } else {
          // 노출된 상품이 없으면 팝업만 내림
          socket.emit("Stock Over", { exposure_active: false, name: "", price: 0, product_num: null });
        }
      }
    } catch (e) {
      console.error("실시간 상품 노출 발송 실패:", e);
    }
  };

  const [originList, setOriginList] = useState<Live_itemList[]>([]); // 검사용
  const [itemlist, setItemList] = useState<Live_itemList[]>([]);
  const drafts = useRef({ itemlist, originList });
  drafts.current = { itemlist, originList };
  const [searchWord, setSearchWord] = useState("");
  const [statusFilter, setStatusFilter] = useState<'전체' | '대기' | '판매' | '판매노출' | '품절'>('전체');
  const pendingProductChanges = useRef(new Map<number, Partial<Live_itemList>>());
  const pendingThumbnails = useRef(new Map<number, { imgPath: string; previous: Set<string> }>());
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState("");
  const listRequestRef = useRef(0);
  const pendingListReads = useRef(0);
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [bulkStatus, setBulkStatus] = useState('판매');
  const [saving, setSaving] = useState(false);
  const savingRef = useRef(false);
  const currentLiveRef = useRef(seq);
  currentLiveRef.current = seq;
  const [saveError, setSaveError] = useState('');
  const [printingQr, setPrintingQr] = useState(false);
  const [actionNotice, setActionNotice] = useState<{ message: string; id: number } | null>(null);
  const showActionNotice = (message = '수정 완료') => setActionNotice(previous => ({ message, id: (previous?.id ?? 0) + 1 }));
  useEffect(() => {
    if (!actionNotice) return;
    const timer = window.setTimeout(() => setActionNotice(null), 3000);
    return () => window.clearTimeout(timer);
  }, [actionNotice]);
  const selectAllRef = useRef<HTMLInputElement>(null);
  const rowDragRef = useRef<{ seq: number; startX: number; startY: number; active: boolean } | null>(null);
  const [draggedSeq, setDraggedSeq] = useState<number | null>(null);
  const [dropTargetSeq, setDropTargetSeq] = useState<number | null>(null);
  const [dropPlacement, setDropPlacement] = useState<'before' | 'after'>('after');
  const [dragPointer, setDragPointer] = useState<{ x: number; y: number } | null>(null);

  const [detailSeq, setDetailSeq] = useState<number | null>(null);
  const [menuSeq, setMenuSeq] = useState<number | null>(null);
  const menuAnchor = useRef<HTMLButtonElement | null>(null);
  const [salesManagementOpen, setSalesManagementOpen] = useState(false);
  useEffect(() => {
    if (menuSeq === null) return;
    const close = (event: MouseEvent) => { if (!(event.target as Element).closest('[data-product-menu]')) setMenuSeq(null); };
    const escape = (event: KeyboardEvent) => { if (event.key === 'Escape') setMenuSeq(null); };
    const owner = menuAnchor.current?.ownerDocument || document;
    owner.addEventListener('click', close); owner.addEventListener('keydown', escape);
    return () => { owner.removeEventListener('click', close); owner.removeEventListener('keydown', escape); };
  }, [menuSeq]);
  const suppressRowClick = useRef(false);
  const [descModalOpen, setDescModalOpen] = useState(false);
  const [registrationOpen, setRegistrationOpen] = useState(false);
  const [registrationBusy, setRegistrationBusy] = useState(false);
  useEffect(() => {
    if (canRegister) return;
    setRegistrationOpen(false);
    setRegistrationCaptureOpen(false);
    setLoadPastOpen(false);
  }, [canRegister]);
  const [loadPastOpen, setLoadPastOpen] = useState(false);
  const [importMessage, setImportMessage] = useState('');
  useEffect(() => {
    if (!importMessage.startsWith('상품 창고에서 ')) return;
    const timer = window.setTimeout(() => setImportMessage(''), 3000);
    return () => window.clearTimeout(timer);
  }, [importMessage]);
  const [selectedProductSeq, setSelectedProductSeq] = useState<number | null>(null);
  const [currentDesc, setCurrentDesc] = useState("");

  const openDescModal = (seq: number, desc: string) => {
    setSelectedProductSeq(seq);
    setCurrentDesc(desc || "");
    setDescModalOpen(true);
  };

  const saveProductDesc = (updatedDesc: string) => {
    if (selectedProductSeq === null) return;
    const updatedList = itemlist.map((item) =>
      item.seq === selectedProductSeq ? { ...item, description: updatedDesc } : item
    );
    setItemList(updatedList);
    void product_update(updatedList);
    setDescModalOpen(false);
  };

  const [imgModalOpen, setImgModalOpen] = useState(false);
  const [selectedImgProductSeq, setSelectedImgProductSeq] = useState<number | null>(null);
  const [currentImages, setCurrentImages] = useState<string[]>([]);
  const productPicturesRef = useRef<{ seq: number; imgPath: string }[]>([]);
  const imageUploadAbort = useRef<AbortController | null>(null);

  useEffect(() => () => {
    imageUploadAbort.current?.abort();
    savingRef.current = false;
  }, [seq]);

  const openImgModal = async (productSeq: number, _currentImgs: string[] | undefined, _fallbackImg: string | undefined) => {
    if (savingRef.current || listLoading || listError) return;
    const requestedLive = seq;
    savingRef.current = true;
    setSaving(true);
    setSaveError('');
    try {
      const response = await api.get(url.Communication_url.product_picture_list, { params: { product_seq: productSeq } });
      if (requestedLive !== currentLiveRef.current) return;
      if (!Array.isArray(response.data)) throw new Error('이미지 목록 응답을 확인할 수 없습니다.');
      productPicturesRef.current = response.data;
      setSelectedImgProductSeq(productSeq);
      setCurrentImages(response.data.map((picture: { imgPath: string }) => mediaUrl(picture.imgPath)));
      setImgModalOpen(true);
    } catch (error) {
      if (requestedLive === currentLiveRef.current) setSaveError(productRequestError(error, '상품 이미지를 불러오지 못했습니다.'));
    } finally {
      if (requestedLive === currentLiveRef.current) {
        savingRef.current = false;
        setSaving(false);
      }
    }
  };

  const saveProductImages = async (updatedImages: string[]) => {
    if (selectedImgProductSeq === null || savingRef.current) throw new Error('다른 저장 작업이 끝난 뒤 다시 시도해주세요.');
    const requestedLive = seq;
    const keepIds: number[] = [];
    const newImages: string[] = [];
    for (const image of updatedImages) {
      const existing = productPicturesRef.current.find(picture => mediaUrl(picture.imgPath) === image);
      if (existing) keepIds.push(existing.seq);
      else if (image.startsWith('blob:')) newImages.push(image);
      else throw new Error('등록된 이미지 또는 직접 선택한 사진만 저장할 수 있습니다.');
    }
    savingRef.current = true;
    setSaving(true);
    const controller = new AbortController();
    imageUploadAbort.current = controller;
    try {
      let newUploadSessionId: string | undefined;
      let newImageObjectIds: string[] | undefined;
      if (newImages.length) {
        const files: File[] = [];
        for (let index = 0; index < newImages.length; index++) {
          const blob = await (await fetch(newImages[index], { signal: controller.signal })).blob();
          if (!['image/jpeg', 'image/png'].includes(blob.type)) throw new Error('JPG 또는 PNG 이미지를 선택해주세요.');
          files.push(new File([blob], `product-${index}.${blob.type === 'image/png' ? 'png' : 'jpg'}`, { type: blob.type }));
        }
        const upload = await directUploadFiles(files, { purpose: 'product-image', liveSeq: Number(seq), signal: controller.signal });
        newUploadSessionId = upload.sessionId;
        newImageObjectIds = upload.objects.map(object => object.objectId);
      }
      const uploadedIdsByImage = new Map(newImages.map((image, index) => [image, newImageObjectIds?.[index]]));
      const pictureOrder = updatedImages.map(image => {
        const existing = productPicturesRef.current.find(picture => mediaUrl(picture.imgPath) === image);
        if (existing) return `existing:${existing.seq}`;
        const objectId = uploadedIdsByImage.get(image);
        if (!objectId) throw new Error('새 이미지의 업로드 결과를 확인할 수 없습니다.');
        return `new:${objectId}`;
      });
      if (requestedLive !== currentLiveRef.current) throw new Error('방송이 변경되어 이미지 연결을 중단했습니다.');
      const response = await api.patch(url.Communication_url.product_picture_update, {
        productSeq: selectedImgProductSeq, keep_seq_list: keepIds,
        ...(newUploadSessionId ? { newUploadSessionId, newImageObjectIds, picture_order: pictureOrder } : {}),
        expected_seq_list: productPicturesRef.current.map(picture => picture.seq),
      }, { headers: { 'Content-Type': 'application/json' }, signal: controller.signal });
      if (!Array.isArray(response.data)) throw new Error('이미지 저장 결과를 확인할 수 없습니다.');
      if (requestedLive !== currentLiveRef.current) return;
      showActionNotice();
      productPicturesRef.current = response.data;
      setCurrentImages(response.data.map((picture: { imgPath: string }) => mediaUrl(picture.imgPath)));
      await load_productList(true);
    } catch (error) {
      throw new Error(productRequestError(error, '이미지를 저장하지 못했습니다. 다시 시도해주세요.'));
    } finally {
      if (imageUploadAbort.current === controller) imageUploadAbort.current = null;
      savingRef.current = false;
      if (requestedLive === currentLiveRef.current) {
        setSaving(false);
      }
    }
  };

  // 실시간 검색은 화면 표시만 필터링(displayList) — itemlist(편집 상태)는 건드리지 않는다.
  const setting_searchword = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchWord(e.target.value);
  };
  const keyPress_keyword = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") search_productList(false);
  };

  const load_productList = async (preserveEdits = false, background = false) => {
    const requestId = ++listRequestRef.current;
    pendingListReads.current += 1;
    inventoryUpdates.current = {}; salesUpdates.current = {};
    if (!background) setListLoading(true);
    setListError("");
    try {
      const res = await api2.get(url.Communication_url.product_list, {
        params: { live_seq: seq }, timeout: 10000,
      });
      if (requestId !== listRequestRef.current) return false;
      if (!Array.isArray(res.data)) throw new Error("상품 목록 응답이 올바르지 않습니다.");
      const data = orderManagedProducts(res.data.map((row: any) => {
        const changes = pendingProductChanges.current.get(row.seq);
        if (changes?.is_pg !== undefined && row.is_pg === changes.is_pg) {
          const remaining = { ...changes }; delete remaining.is_pg;
          if (Object.keys(remaining).length) pendingProductChanges.current.set(row.seq, remaining); else pendingProductChanges.current.delete(row.seq);
        }
        const pending = pendingThumbnails.current.get(row.seq);
        let item = row;
        if (pending) {
          if (pending.previous.has(mediaUrl(row.thumbnail_img || row.product_img || ''))) item = { ...row, thumbnail_img: pending.imgPath };
          else pendingThumbnails.current.delete(row.seq);
        }
        return {
          ...item,
          active_sales_quantity: salesUpdates.current[item.seq]?.quantity ?? Math.max(0, activeSalesQuantity(item) + Number(item.current_cnt) - Number(inventoryUpdates.current[item.seq] ?? item.current_cnt)),
          has_orders: salesUpdates.current[item.seq]?.hasOrders ?? item.has_orders,
          current_cnt: inventoryUpdates.current[item.seq] ?? item.current_cnt,
          ...pendingProductChanges.current.get(item.seq),
          description: item.product_description ?? item.description ?? '',
          product_img: item.thumbnail_img ? mediaUrl(item.thumbnail_img) : item.product_img ?? '',
        };
      }));
      setItemList(preserveEdits ? data.map((fresh: Live_itemList) => {
        const edited = drafts.current.itemlist.find(item => item.seq === fresh.seq);
        const original = drafts.current.originList.find(item => item.seq === fresh.seq);
        if (!edited || !original) return fresh;
        const draft = { ...fresh };
        const fields = ['name', 'product_num', 'price', 'init_cnt', 'description', 'product_img', 'product_imgs', 'per_customer_quantity_limit', 'individual_delivery', 'individual_delivery_price', 'is_tax_exempt'] as const;
        for (const field of fields) {
          if (JSON.stringify(edited[field]) !== JSON.stringify(original[field])) (draft as any)[field] = edited[field];
        }
        return draft;
      }) : data);
      setOriginList(data);
      setSelectedIds(previous => previous.filter(id => data.some((item: Live_itemList) => item.seq === id)));
      setChange_h((pre) => pre + 1);
      return true;
    } catch (error) {
      if (requestId !== listRequestRef.current) return false;
      console.error("데이터 로드 실패1:", error);
      setListError(productRequestError(error, "상품 목록을 불러오지 못했습니다. 다시 시도해주세요."));
      return false;
    } finally {
      pendingListReads.current -= 1;
      if (requestId === listRequestRef.current) setListLoading(false);
    }
  };

  useEffect(() => {
    // Shared broadcast sockets already refresh this list through refreshVersion.
    if (!socket || liveSocket !== undefined) return;
    const refreshInventory = () => { void load_productList(true, true); };
    const refreshProducts = (update: { liveSeq: number }) => {
      if (Number(update?.liveSeq) === Number(seq)) refreshInventory();
    };
    socket.on('connect', refreshInventory);
    socket.on('Product List Changed', refreshProducts);
    return () => {
      socket.off('connect', refreshInventory);
      socket.off('Product List Changed', refreshProducts);
    };
  }, [socket, liveSocket, seq]);

  useEffect(() => {
    // A tablet can save a photo while this tab misses its socket notification.
    // Reconcile visible lists without replacing the seller's unsaved edits.
    const refresh = () => {
      if (document.hidden || pendingListReads.current || savingRef.current) return;
      void load_productList(true, true);
    };
    const timer = window.setInterval(refresh, 5000);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, [seq]);

  const previousRefreshVersion = useRef(refreshVersion);
  useEffect(() => {
    if (previousRefreshVersion.current === refreshVersion) return;
    previousRefreshVersion.current = refreshVersion;
    void load_productList(true, true);
  }, [refreshVersion]);

  const previousPaymentMode = useRef(paymentMode);
  useEffect(() => {
    if (previousPaymentMode.current !== paymentMode) {
      previousPaymentMode.current = paymentMode;
      load_productList(true);
    }
  }, [paymentMode]);
  const warehouseProductsImported = async (count: number) => {
    if (!canManage || !canRegister) throw new Error(registrationDisabledReason || '상품을 등록할 수 없는 방송입니다.');
    const requestedLive = seq;
    setImportMessage('');
    if (requestedLive !== currentLiveRef.current) throw new Error('방송이 변경되었습니다. 현재 상품 목록을 확인해주세요.');

    // Registration is confirmed by POST. A newer socket refresh may supersede this
    // list request; actual fetch errors and retry belong to the list's error state.
    setImportMessage(`상품 창고에서 ${count}개 상품 등록이 완료되었습니다.`);
    showActionNotice('등록 완료');
    await load_productList();
  };

  useEffect(() => {
    load_productList();
    return () => { listRequestRef.current += 1; };
  }, [change, seq]);

  useEffect(() => {
    pendingProductChanges.current.clear();
    pendingThumbnails.current.clear();
    savingRef.current = false;
    setSaving(false);
    setSaveError('');
    setSelectedIds([]);
    setImgModalOpen(false);
    setRegistrationOpen(false);
    setRegistrationCaptureOpen(false);
    setSalesManagementOpen(false);
    setActionNotice(null);
  }, [seq]);

  const savePaymentMethod = async (product: Live_itemList, isPg: boolean) => {
    if (!canManage || paymentMode !== 'combined' || savingRef.current || listLoading || listError) return;
    const requestedLive = seq;
    savingRef.current = true; setSaving(true); setSaveError('');
    const previous = product.is_pg;
    pendingProductChanges.current.set(product.seq, { ...pendingProductChanges.current.get(product.seq), is_pg: isPg });
    setItemList(items => items.map(item => item.seq === product.seq ? { ...item, is_pg: isPg } : item));
    try {
      await api.post(`${SERVER_ADDRESS}product/payment-method`, { seq: product.seq, is_pg: isPg }, { headers: { 'Content-Type': 'application/json' } });
      if (requestedLive !== currentLiveRef.current) return;
      setOriginList(items => items.map(item => item.seq === product.seq ? { ...item, is_pg: isPg } : item));
      showActionNotice();
    } catch (error) {
      if (requestedLive === currentLiveRef.current) {
        const changes = { ...pendingProductChanges.current.get(product.seq) }; delete changes.is_pg;
        if (Object.keys(changes).length) pendingProductChanges.current.set(product.seq, changes); else pendingProductChanges.current.delete(product.seq);
        setItemList(items => items.map(item => item.seq === product.seq ? { ...item, is_pg: previous } : item));
        setSaveError(productRequestError(error, '상품 결제 방식을 변경하지 못했습니다. 다시 시도해주세요.'));
      }
    } finally {
      if (requestedLive === currentLiveRef.current) { savingRef.current = false; setSaving(false); }
    }
  };
  const selectedProducts = originList.filter(product => selectedIds.includes(product.seq));
  const printSelectedQr = async () => {
    if (!canManage || savingRef.current || printingQr || listLoading || listError || !selectedProducts.length) return;
    setPrintingQr(true);
    setSaveError('');
    try { await printProductQr(selectedProducts.map(product => product.seq)); }
    catch (error) { setSaveError(productRequestError(error, 'QR 인쇄를 준비하지 못했습니다.')); }
    finally { setPrintingQr(false); }
  };
  const deleteBlockedReason = selectedProducts.some(product => product.has_orders)
    ? '구매 이력이 있는 상품은 삭제할 수 없습니다. 주문이 취소되어도 삭제할 수 없습니다.'
    : selectedProducts.some(product => !['대기', '품절'].includes(product.product_status))
      ? '대기 또는 품절 상태의 상품만 삭제할 수 있습니다.'
      : '';
  const deleteHelpId = `product-delete-help-${seq}`;

  const deleteSelectedProducts = async () => {
    if (!canManage || savingRef.current || listLoading || listError || !selectedProducts.length || deleteBlockedReason) return;
    if (!window.confirm(`선택한 상품 ${selectedProducts.length}개를 목록에서 삭제할까요? 구매 이력이 있는 상품은 삭제할 수 없습니다.`)) return;
    const requestedLive = seq;
    savingRef.current = true;
    listRequestRef.current += 1;
    setSaving(true);
    setSaveError('');
    setImportMessage('');
    let deletedCount = 0;
    try {
      for (const product of selectedProducts) {
        const response = await api.delete(url.Communication_url.product_delete, {
          data: { live_seq: Number(requestedLive), product_seq: product.seq },
          headers: { 'Content-Type': 'application/json' },
        });
        if (requestedLive !== currentLiveRef.current) return;
        if (response.data?.success !== true) throw new Error('상품 삭제 결과를 확인할 수 없습니다.');
        deletedCount += 1;
      }
    } catch (error) {
      if (requestedLive !== currentLiveRef.current) return;
      setSaveError(productRequestError(error, '상품을 삭제하지 못했습니다. 새로 불러온 목록을 확인해주세요.'));
    } finally {
      if (requestedLive === currentLiveRef.current) {
        if (deletedCount > 0) {
          setImportMessage(`${deletedCount}개 상품을 삭제했습니다.`);
          if (deletedCount === selectedProducts.length) showActionNotice('삭제 완료');
        }
        await load_productList(true);
        savingRef.current = false;
        setSaving(false);
      }
    }
  };

  const reorderProduct = async (draggedSeq: number, targetSeq: number, placement: 'before' | 'after' = 'after') => {
    if (savingRef.current || listLoading || listError || searchWord || statusFilter !== '전체' || !canManage) return;
    const expectedOrder = originList.map(item => item.seq);
    const from = expectedOrder.indexOf(draggedSeq);
    if (from < 0 || !expectedOrder.includes(targetSeq) || draggedSeq === targetSeq) return;
    const orderedIds = expectedOrder.filter(id => id !== draggedSeq);
    const targetIndex = orderedIds.indexOf(targetSeq);
    orderedIds.splice(targetIndex + (placement === 'after' ? 1 : 0), 0, draggedSeq);
    if (orderedIds.every((id, index) => id === expectedOrder[index])) return;
    const requestedLive = seq;
    savingRef.current = true;
    listRequestRef.current += 1;
    setSaving(true);
    setSaveError('');
    try {
      const response = await api.patch(url.Communication_url.product_reorder, {
        live_seq: Number(seq), expected_order: expectedOrder, ordered_ids: orderedIds,
      }, { headers: { 'Content-Type': 'application/json' } });
      if (requestedLive !== currentLiveRef.current) return;
      if (response.data?.success !== true) throw new Error('상품 순서 저장 결과를 확인할 수 없습니다.');
      showActionNotice();
      await load_productList(true, compact);
    } catch (error) {
      if (requestedLive !== currentLiveRef.current) return;
      setSaveError(productRequestError(error, '상품 순서를 저장하지 못했습니다. 새로 불러온 목록을 확인해주세요.'));
      await load_productList(true);
    } finally {
      if (requestedLive === currentLiveRef.current) {
        savingRef.current = false;
        setSaving(false);
      }
    }
  };

  const finishDrag = () => {
    rowDragRef.current = null;
    setDraggedSeq(null);
    setDropTargetSeq(null);
    setDragPointer(null);
  };

  const dropLocationAt = (clientX: number, clientY: number, fallback: EventTarget | null, dragged: number) => {
    const element = (document.elementFromPoint?.(clientX, clientY) ?? fallback) as Element | null;
    const target = element?.closest('[data-product-seq]') as HTMLElement | null;
    const seqValue = target?.getAttribute('data-product-seq');
    if (!seqValue) return null;
    const targetSeq = Number(seqValue);
    if (targetSeq === dragged) return null;
    const slot = target?.getAttribute('data-drop-placement');
    const bounds = target?.getBoundingClientRect();
    const placement = slot === 'before' || slot === 'after' ? slot
      : targetSeq === displayList[0]?.seq && (bounds?.height
        ? clientY < bounds.top + bounds.height / 2
        : displayList.findIndex(item => item.seq === dragged) > 0)
        ? 'before' : 'after';
    return { seq: targetSeq, placement: placement as 'before' | 'after' };
  };

  const startRowDrag = (event: React.MouseEvent<HTMLElement> | React.PointerEvent<HTMLElement>, productSeq: number, fromHandle = false) => {
    if (!canManage || savingRef.current || listLoading || listError || searchWord || statusFilter !== '전체'
      || event.button !== 0
      || (!fromHandle && (event.target as HTMLElement).closest('input, button, select, textarea, [contenteditable]'))) return;
    event.preventDefault();
    suppressRowClick.current = false;
    rowDragRef.current = { seq: productSeq, startX: event.clientX, startY: event.clientY, active: false };
  };

  const moveRowDrag = (event: React.MouseEvent<HTMLElement> | React.PointerEvent<HTMLElement>) => {
    const drag = rowDragRef.current;
    if (!drag) return;
    if (!drag.active && Math.hypot(event.clientX - drag.startX, event.clientY - drag.startY) < 5) return;
    drag.active = true;
    suppressRowClick.current = true;
    setDraggedSeq(drag.seq);
    setDragPointer({ x: event.clientX, y: event.clientY });
    const target = dropLocationAt(event.clientX, event.clientY, event.target, drag.seq);
    setDropTargetSeq(target?.seq ?? null);
    if (target) setDropPlacement(target.placement);
  };

  const endRowDrag = (event: React.MouseEvent<HTMLElement> | React.PointerEvent<HTMLElement>) => {
    const drag = rowDragRef.current;
    if (!drag) return;
    const target = dropLocationAt(event.clientX, event.clientY, event.target, drag.seq);
    finishDrag();
    if (drag.active && target) void reorderProduct(drag.seq, target.seq, target.placement);
  };

  // 검색은 클라이언트 필터(displayList)로 처리 — 서버 재조회로 itemlist/originList를
  // 덮어쓰면 편집 상태가 날아가므로, 여기서는 검색어 세팅/초기화만 한다.
  const search_productList = (reset: boolean) => {
    if (reset) setSearchWord("");
  };

  const setting_price = (
    e: React.ChangeEvent<HTMLInputElement>,
    seq: number
  ) => {
    const price = e.target.value;
    const updatedList = itemlist.map((item) =>
      item.seq === seq ? { ...item, price: price } : item
    );
    setItemList(updatedList);
  };
  const setting_product_code = (e: React.ChangeEvent<HTMLInputElement>, seq: number) => {
    setItemList(previous => previous.map(item => item.seq === seq
      ? { ...item, product_num: e.target.value }
      : item));
  };
  const setting_product_name = (e: React.ChangeEvent<HTMLInputElement>, seq: number) => {
    setItemList(previous => previous.map(item => item.seq === seq
      ? { ...item, name: e.target.value }
      : item));
  };
  const copyProductName = async (productName: string) => {
    try {
      await navigator.clipboard.writeText(productName);
      showActionNotice('복사 완료');
    } catch {
      setActionNotice(null);
      setSaveError('상품명을 복사하지 못했습니다. 브라우저의 클립보드 권한을 확인해주세요.');
    }
  };
  const setting_init_cnt = (
    e: React.ChangeEvent<HTMLInputElement>,
    seq: number
  ) => {
    const init_cnt = e.target.value;
    const updatedList = itemlist.map((item) =>
      item.seq === seq ? { ...item, init_cnt: Number(init_cnt) } : item
    );
    setItemList(updatedList);
  };
  const setting_product_status = (
    e: React.ChangeEvent<HTMLSelectElement>,
    seq: number
  ) => {
    updateStatuses([seq], e.target.value);
  };

  const updateStatuses = async (ids: number[], choice: string, exposureOff = false, returnToExposure = false) => {
    const [choiceStatus, priceMode] = choice.split(':');
    const exposureChange = exposureOff ? false : choiceStatus === '판매노출' && !priceMode ? true : undefined;
    const status = getProductSaleStatus(choiceStatus)!;
    const mode = ['visible', 'seller'].includes(priceMode) ? priceMode as 'visible' | 'seller' : exposureChange === true ? 'seller' : undefined;
    if (savingRef.current || listLoading || listError || ids.length === 0) return;
    if (exposureChange === true && ids.length > 1) { setSaveError('판매노출은 상품 한 개만 선택해주세요.'); return; }
    if (exposureChange === undefined && !priceMode && status === '판매' && originList.some(item => ids.includes(item.seq) && (!Number.isFinite(Number(item.current_cnt)) || Number(item.current_cnt) < 0))) {
      setSaveError('상품 재고를 확인해주세요.'); return;
    }
    const requestedLive = seq;
    const affected = itemlist.filter(item => ids.includes(item.seq) || (exposureChange === true && hasProductExposure(item)));
    const previousChanges = new Map<number, Partial<Live_itemList>>(affected.map(item => [item.seq, {
      product_status: item.product_status, exposure_active: item.exposure_active,
      exposure_price_mode: item.exposure_price_mode, exposure_pending: item.exposure_pending,
    }]));
    const nextChanges = new Map<number, Partial<Live_itemList>>(affected.map(item => {
      const selected = ids.includes(item.seq);
      const exposed = selected ? exposureChange ?? hasProductExposure(item) : false;
      const nextStatus = selected && exposureChange === undefined && !priceMode ? status : getProductSaleStatus(item.product_status)!;
      return [item.seq, {
        product_status: nextStatus, exposure_active: exposed,
        exposure_price_mode: exposed ? selected && mode ? mode : item.exposure_price_mode : 'seller',
        exposure_pending: returnToExposure || !selected || exposureChange === true ? true : exposureChange === false || priceMode ? item.exposure_pending : status === '판매' ? false : item.exposure_pending,
      }];
    }));
    const applyChanges = (items: Live_itemList[], changes: Map<number, Partial<Live_itemList>>) => items.map(item =>
      changes.has(item.seq) ? { ...item, ...changes.get(item.seq) } : item);
    pendingProductChanges.current = nextChanges;
    savingRef.current = true;
    setSaving(true);
    setSaveError('');
    setItemList(previous => applyChanges(previous, nextChanges));
    try {
      const res = await api.patch(url.Communication_url.product_update, {
        live_seq: Number(seq), product_list: ids.map(id => ({ seq: id, ...(returnToExposure ? { return_to_exposure: true } : exposureChange !== undefined ? { exposure_active: exposureChange } : priceMode ? {} : { product_status: status }), ...(mode ? { exposure_price_mode: mode } : {}) })),
      }, { headers: { 'Content-Type': 'application/json' } });
      if (requestedLive !== currentLiveRef.current) return;
      if (res.data.total !== ids.length || res.data.success !== ids.length || res.data.fail !== 0) {
        throw new Error('일부 상품 상태를 변경하지 못했습니다. 목록을 확인해주세요.');
      }
      listRequestRef.current += 1;
      setListLoading(false);
      pendingProductChanges.current.clear();
      setItemList(previous => applyChanges(previous, nextChanges));
      setOriginList(previous => applyChanges(previous, nextChanges));
      setChange_h(previous => previous + 1);
      setSelectedIds(previous => previous.filter(id => !ids.includes(id)));
      showActionNotice();
    } catch (error) {
      if (requestedLive !== currentLiveRef.current) return;
      pendingProductChanges.current.clear();
      setItemList(previous => applyChanges(previous, previousChanges));
      setOriginList(previous => applyChanges(previous, previousChanges));
      setSaveError(productRequestError(error, '상품 상태를 변경하지 못했습니다. 다시 시도해주세요.'));
      await load_productList(true, true);
    } finally {
      if (requestedLive === currentLiveRef.current) {
        pendingProductChanges.current.clear();
        savingRef.current = false;
        setSaving(false);
      }
    }
  };

  const restoreSoldOut = async (productSeq: number) => {
    if (savingRef.current || listLoading || listError) return;
    const requestedLive = seq;
    savingRef.current = true;
    setSaving(true);
    setSaveError('');
    try {
      const res = await api.patch(url.Communication_url.product_update, {
        live_seq: Number(seq), product_list: [{ seq: productSeq, restore_sold_out: true }],
      }, { headers: { 'Content-Type': 'application/json' } });
      if (requestedLive !== currentLiveRef.current) return;
      if (res.data.total !== 1 || res.data.success !== 1 || res.data.fail !== 0) {
        throw new Error('품절 상태를 해제하지 못했습니다. 목록을 확인해주세요.');
      }
      // The server restores the saved state and resolves any competing exposure.
      if (await load_productList(true, true)) showActionNotice();
    } catch (error) {
      if (requestedLive !== currentLiveRef.current) return;
      setSaveError(productRequestError(error, '품절을 해제하지 못했습니다. 다시 시도해주세요.'));
      await load_productList(true, true);
    } finally {
      if (requestedLive === currentLiveRef.current) {
        savingRef.current = false;
        setSaving(false);
      }
    }
  };

  const retryVideoExposure = async () => {
    if (savingRef.current || !seq) return;
    savingRef.current = true;
    setSaving(true);
    try {
      await api.post(url.Communication_url.product_exposure_retry, { live_seq: Number(seq) });
      setSaveError('');
      setImportMessage('현재 상품 노출을 영상에 다시 전송했습니다. 시청 화면에는 영상 지연에 맞춰 반영됩니다.');
      showActionNotice('전송 완료');
    } catch (error) {
      setSaveError(productRequestError(error, '영상 상품 노출을 다시 전송하지 못했습니다.'));
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  };

  const saveCompactValue = async (productSeq: number, field: 'name' | 'price' | 'stock', value: string | number) => {
    value = String(value ?? '');
    const item = drafts.current.itemlist.find(product => product.seq === productSeq);
    if (!item || !canManage || savingRef.current) return false;
    if (field === 'price' && priceEditLocked(item)) { setSaveError(priceLockMessage); return false; }
    if (field === 'name' && item.product_status !== '대기') { setSaveError('상품명은 대기 상태에서 수정할 수 있습니다.'); return false; }
    if ((field === 'name' && !value.trim()) || (field !== 'name' && (!value.trim() || !Number.isSafeInteger(Number(value)) || Number(value) < 0))) {
      setSaveError(field === 'name' ? '상품명을 입력해주세요.' : '0 이상의 정수를 입력해주세요.'); return false;
    }
    const next = field === 'name' ? { ...item, name: value.trim() }
      : field === 'price' ? { ...item, price: value }
      : { ...item, init_cnt: Number(item.init_cnt) + Number(value) - Number(item.current_cnt) };
    const saved = await product_update([next]);
    if (saved) {
      setItemList(items => items.map(product => product.seq === productSeq ? { ...product,
        ...(field === 'name' ? { name: next.name } : field === 'price' ? { price: next.price } : { init_cnt: next.init_cnt }) } : product));
      if (field === 'stock') await load_productList(true);
    }
    return saved;
  };

  // 화면 표시용 목록 — 검색어로 itemlist를 필터링(편집 상태는 itemlist에 그대로 보존)
  const matchesStatusFilter = (item: Live_itemList, status: typeof statusFilter) => status === '전체'
    || (status === '판매노출' ? hasProductExposure(item) : status === '품절' ? isSoldOut(item) || Number(item.current_cnt) <= 0
      : isVisibleManagedProduct(item) && getProductSaleStatus(item.product_status) === status);
  const statusMatches = itemlist.filter(item => matchesStatusFilter(item, statusFilter));
  const exactMatches = statusMatches.filter(item => matchesProductName(item.name, searchWord));
  const displayList = exactMatches.length || !searchWord.trim() ? exactMatches
    : statusMatches.filter(item => matchesProductTypo(item.name, searchWord));
  const selectableDisplayList = displayList;
  const allDisplayedSelected = selectableDisplayList.length > 0 && selectableDisplayList.every(item => selectedIds.includes(item.seq));
  useEffect(() => {
    if (selectAllRef.current) selectAllRef.current.indeterminate = !allDisplayedSelected && selectableDisplayList.some(item => selectedIds.includes(item.seq));
  }, [selectableDisplayList, selectedIds, allDisplayedSelected]);
  const toggleAllDisplayed = () => {
    const displayedIds = displayList.map(item => item.seq);
    setSelectedIds(previous => {
      const otherSelectedIds = previous.filter(id => !displayedIds.includes(id));
      return allDisplayedSelected ? otherSelectedIds : [...otherSelectedIds, ...selectableDisplayList.map(item => item.seq)];
    });
  };
  const product_update = async (list: Live_itemList[] = itemlist) => {
    if (savingRef.current || listLoading || listError) return false;
    const blockedPrice = list.find(item => {
      const original = originList.find(saved => saved.seq === item.seq);
      return original && Number(item.price) !== Number(original.price) && priceEditLocked(original);
    });
    if (blockedPrice) { setSaveError(priceLockMessage); return false; }
    if (list.some(item => { const original = originList.find(saved => saved.seq === item.seq); return original && item.name.trim() !== original.name && original.product_status !== '대기'; })) {
      setSaveError('상품명은 대기 상태에서 수정할 수 있습니다.'); return false;
    }
    if (list.some(item => !Number.isSafeInteger(Number(item.individual_delivery_price ?? 0)) || Number(item.individual_delivery_price ?? 0) < 0 || Number(item.individual_delivery_price ?? 0) > 2147483647)) { setSaveError('개별 배송비는 0원 이상의 정수로 입력해주세요.'); return false; }
    const updateList2 = list.flatMap(item => {
      const original = originList.find(saved => saved.seq === item.seq);
      if (!original) return [];
      const changes: { is_tax_exempt?: boolean; individual_delivery?: boolean; individual_delivery_price?: number; seq: number; name?: string; product_num?: string; price?: number; init_cnt?: number; product_description?: string; per_customer_quantity_limit?: number | null } = { seq: item.seq };
      if (item.name.trim() !== original.name) changes.name = item.name.trim();
      if (String(item.product_num ?? '') !== String(original.product_num ?? '')) {
        changes.product_num = String(item.product_num ?? '').trim();
      }
      if (Number(item.price) !== Number(original.price)) changes.price = Number(item.price);
      if (!hasRegisteredOptions(item) && Number(item.init_cnt) !== Number(original.init_cnt)) changes.init_cnt = Number(item.init_cnt);
      if ((item.per_customer_quantity_limit ?? null) !== (original.per_customer_quantity_limit ?? null)) changes.per_customer_quantity_limit = item.per_customer_quantity_limit ?? null;
      if (!!item.is_tax_exempt !== !!original.is_tax_exempt) changes.is_tax_exempt = !!item.is_tax_exempt;
      if (!!item.individual_delivery !== !!original.individual_delivery) changes.individual_delivery = !!item.individual_delivery;
      if (Number(item.individual_delivery_price ?? 0) !== Number(original.individual_delivery_price ?? 0)) changes.individual_delivery_price = Number(item.individual_delivery_price ?? 0);
      if ((item.description ?? '') !== (original.description ?? '')) changes.product_description = item.description ?? '';
      return Object.keys(changes).length > 1 ? [changes] : [];
    });
    if (updateList2.length === 0) return true;

    savingRef.current = true;
    setSaving(true);
    setSaveError('');
    try {
      const res = await api.patch(
        url.Communication_url.product_update,
        { live_seq: Number(seq), product_list: updateList2 },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.fail > 0) {
        notifyLive(`수정실패 (${res.data.fail}/${res.data.total})`);
      }
      if (res.data.fail === 0 && res.data.total === updateList2.length && res.data.success === updateList2.length) {
        showActionNotice();
      }
      if (res.data.success > 0) {
        if (res.data.fail === 0 && res.data.success === updateList2.length) {
          setOriginList(previous => previous.map(item => {
            const saved = updateList2.find(update => update.seq === item.seq);
            return saved ? { ...item,
              ...(saved.name !== undefined ? { name: saved.name } : {}),
              ...(saved.product_num !== undefined ? { product_num: saved.product_num } : {}),
              ...(saved.price !== undefined ? { price: String(saved.price) } : {}),
              ...(saved.init_cnt !== undefined ? { init_cnt: saved.init_cnt } : {}),
              ...(saved.per_customer_quantity_limit !== undefined ? { per_customer_quantity_limit: saved.per_customer_quantity_limit } : {}),
              ...(saved.product_description !== undefined ? { description: saved.product_description } : {}),
              ...(saved.is_tax_exempt !== undefined ? { is_tax_exempt: saved.is_tax_exempt } : {}),
              ...(saved.individual_delivery !== undefined ? { individual_delivery: saved.individual_delivery } : {}),
              ...(saved.individual_delivery_price !== undefined ? { individual_delivery_price: saved.individual_delivery_price } : {}),
            } : item;
          }));
          setChange_h(previous => previous + 1);
        } else {
          await load_productList(true);
        }
      }
      return res.data.fail === 0 && res.data.success === updateList2.length;
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
      setSaveError(productRequestError(error, '상품을 저장하지 못했습니다. 다시 시도해주세요.'));
      return false;
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  };

  const [loading_onoff, setLoading_onoff] = useState(false);
  const update_cancle_check = async () => {
    if (loading_onoff) {
      return;
    }
    setLoading_onoff(true);

    // try {
    //   const res = await api.patch(url.Communication_url.update_cancle_check, {
    //     seq: seq,
    //     cancle_check: live_cancle_check ? "n" : "y",
    //   });
    //   // console.log(res.data);
    //   if (res.data === "성공") {
    //     setLive_cancle_check(!live_cancle_check);
    //   }
    // } catch (error) {
    //   console.error("데이터 로드 실패1:", error);
    // } finally {
    //   setLoading_onoff(false);
    // }
  };

  // 옵션
  const optionRef = useRef<{ setData: (data: any) => void }>(null);
  const openOptionBox = (
    yn: boolean,
    seq: number,
    product_status: string,
    live_seq: number,
    store_info: StoreInfo,
    current_cnt: number,
    stockEdit = false
  ) => {
    const product = drafts.current.itemlist.find(item => item.seq === seq);
    const stockOnly = stockEdit || !!(product && optionStructureLocked(product) && hasRegisteredOptions(product));
    if (product && optionStructureLocked(product) && !stockOnly) { setSaveError(inventoryLockMessage); return; }
    if (optionRef.current) {
      optionRef.current.setData({
        yn,
        seq,
        product_status,
        live_seq,
        store_info,
        current_cnt,
        stockOnly,
        structureLocked: !!(product && optionStructureLocked(product)),
      });
    }
  };
  const cancelProductOrders = async (product: Live_itemList) => {
    setMenuSeq(null);
    if (savingRef.current || !canManage || !cancelReason.trim()) return;
    const requestedLive = seq; savingRef.current = true; setSaving(true); setSaveError('');
    try {
      const { data } = await api.post(`${SERVER_ADDRESS}orders/cancel-product-pending`, { live_seq: Number(seq), product_seq: product.seq, reason: cancelReason.trim(), request_id: cancelRequestId });
      if (requestedLive !== currentLiveRef.current) return;
      if (data?.product_status !== '대기' || !Number.isInteger(data.success)) throw new Error('취소 결과를 확인하지 못했습니다. 목록을 다시 불러와주세요.');
      setImportMessage(`주문 ${data.success}건을 취소하고 상품을 대기로 전환했습니다.`);
      if (data.fail > 0) setSaveError(`${data.fail}건은 주문·결제 상태가 변경되어 취소되지 않았습니다. 주문 목록을 확인해주세요.`);
      if (data.syncWarning) setSaveError('취소는 완료됐지만 화면 갱신에 실패했습니다. 목록을 다시 불러와주세요.');
      if (!data.fail) { showActionNotice('취소 완료'); setCancelTarget(null); }
      setChange_h(value => value + 1); onInventoryChange?.(); await load_productList();
    } catch (error) { if (requestedLive === currentLiveRef.current) setSaveError(productRequestError(error, '주문을 취소하지 못했습니다. 다시 시도해주세요.')); }
    finally { if (requestedLive === currentLiveRef.current) { savingRef.current = false; setSaving(false); } }
  };
  const productDetails = (detailProduct: Live_itemList) => (<ProductDetails onKeyDown={event => {
    if (!compact || event.nativeEvent.isComposing || event.key !== 'Enter') return;
    const target = event.target as HTMLElement;
    if (!['INPUT', 'TEXTAREA'].includes(target.tagName) || (target.tagName === 'TEXTAREA' && !event.ctrlKey && !event.metaKey)) return;
    event.preventDefault(); void product_update([detailProduct]);
  }}>
    <DetailHeading><DetailActions><SecondaryAction type="button" disabled={!canManage || saving || (optionStructureLocked(detailProduct) && !hasRegisteredOptions(detailProduct))} onClick={() => { setDetailSeq(null); openOptionBox(detailProduct.option_check === 'y', detailProduct.seq, detailProduct.product_status, detailProduct.live_seq, store_info, detailProduct.current_cnt); }}>
        옵션 {detailProduct.option_check === 'y' ? '수정' : '설정'}</SecondaryAction>
        <SecondaryAction type="button" disabled={!canManage || saving} onClick={() => { setDetailSeq(null); void openImgModal(detailProduct.seq, detailProduct.product_imgs, detailProduct.product_img); }}>상품 이미지 수정</SecondaryAction>
</DetailActions>
    </DetailHeading>
    <DetailFields>
      <label>상품 코드<InputBox aria-label="상세 상품 코드" value={detailProduct.product_num ?? ''} maxLength={255} disabled={!canManage || saving}
        onChange={event => setting_product_code(event, detailProduct.seq)} onBlur={() => void product_update([detailProduct])} /></label>
      <label>상품명<InputBox aria-label="상세 상품명" value={detailProduct.name} disabled={!canManage || saving || detailProduct.product_status !== '대기'}
        onChange={event => setting_product_name(event, detailProduct.seq)} onBlur={() => void product_update([detailProduct])} /></label>
      <label>금액<InputBox type="number" aria-label="상세 금액" min={0} step={1} value={detailProduct.price} disabled={!canManage || saving || priceEditLocked(detailProduct)}
        title={priceEditLocked(detailProduct) ? priceLockMessage : undefined} onChange={event => setting_price(event, detailProduct.seq)} onBlur={() => void product_update([detailProduct])} /></label>
      {paymentMode === 'combined' && <PaymentSetting type="button" className="payment-choice" aria-label="상세 PG 결제" aria-pressed={detailProduct.is_pg !== false}
        disabled={!canManage || saving} onClick={() => void savePaymentMethod(detailProduct, detailProduct.is_pg === false)}>{detailProduct.is_pg !== false ? 'PG' : '무통장'}</PaymentSetting>}
    </DetailFields>
    {compact && <DetailDescription>1인당 구매 수량 제한<InputBox type="number" aria-label="상세 1인당 구매 수량 제한" min={1} max={2147483647} step={1}
      placeholder="제한 없음" value={detailProduct.per_customer_quantity_limit ?? ''} disabled={!canManage || saving}
      onChange={event => { const value = event.target.value === '' ? null : Number(event.target.value); if (value !== null && (!Number.isSafeInteger(value) || value < 1 || value > 2147483647)) return;
        setItemList(items => items.map(item => item.seq === detailProduct.seq ? { ...item, per_customer_quantity_limit: value } : item)); }}
      onBlur={() => void product_update([detailProduct])} /><small>이 상품의 모든 옵션 합산 · 취소 수량 제외 · 비워두면 제한 없음</small></DetailDescription>}
    <PaymentSetting type="button" aria-label="상세 면세 여부" aria-pressed={!!detailProduct.is_tax_exempt} disabled={!canManage || saving}
      onClick={() => { const next = { ...detailProduct, is_tax_exempt: !detailProduct.is_tax_exempt }; setItemList(items => items.map(item => item.seq === next.seq ? next : item)); void product_update([next]); }}>면세 {detailProduct.is_tax_exempt ? "Y" : "X"}</PaymentSetting>
    <DeliveryDetails><DeliveryChoice type="button" aria-label="상세 개별 배송" aria-pressed={!!detailProduct.individual_delivery} disabled={!canManage || saving}
      onClick={() => { const next = { ...detailProduct, individual_delivery: !detailProduct.individual_delivery }; setItemList(items => items.map(item => item.seq === next.seq ? next : item)); void product_update([next]); }}>개별 배송</DeliveryChoice>
      {detailProduct.individual_delivery && <label><span>개별 배송비</span><CurrencyInput><InputBox type="number" aria-label="상세 개별 배송비" min={0} max={2147483647} step={1}
        value={detailProduct.individual_delivery_price ?? 0} disabled={!canManage || saving}
        onChange={event => setItemList(items => items.map(item => item.seq === detailProduct.seq ? { ...item, individual_delivery_price: Number(event.target.value) } : item))}
        onBlur={() => void product_update([detailProduct])} /><span aria-hidden="true">원</span></CurrencyInput></label>}
    </DeliveryDetails>
    <DetailDescription>상품 설명<textarea aria-label="상세 상품 설명" value={detailProduct.description ?? ''} disabled={!canManage || saving}
      onChange={event => setItemList(items => items.map(item => item.seq === detailProduct.seq ? { ...item, description: event.target.value } : item))}
      onBlur={() => void product_update([detailProduct])} /></DetailDescription>
    {compact && <KeyboardHelp>입력창은 Enter로 적용 · 설명은 Ctrl/⌘+Enter로 적용</KeyboardHelp>}
    {saveError && <LiveFeedback role="alert">{saveError}</LiveFeedback>}
  </ProductDetails>);

  return (
    <>
      <ListHeader>
        <div>
          <Eyebrow>판매 상품 관리</Eyebrow>
          <h2>상품 목록 {!listLoading && !listError && <CountBadge>{originList.length}</CountBadge>}</h2>
        </div>
        {canManage && <HeaderActions>
          {compact && <SecondaryAction type="button" onClick={() => setSalesManagementOpen(true)}><LiveToolbarIcon name="tools" />판매 관리</SecondaryAction>}
          <SecondaryAction type="button" disabled={!canRegister} title={!canRegister ? registrationDisabledReason : undefined} onClick={() => setLoadPastOpen(true)}>
            <Icon aria-hidden="true" src={require("../../../../Image/Admin/ic_refresh.png")} />
            상품 창고에서 불러오기
          </SecondaryAction>

          <PrimaryAction type="button" disabled={!canRegister} title={!canRegister ? registrationDisabledReason : undefined} onClick={() => setRegistrationOpen(true)}>
            {compact ? '상품 바로 등록' : '상품 등록'}
          </PrimaryAction>
        </HeaderActions>}
      </ListHeader>
      <StatusFilterRow><StatusTabs role="tablist" aria-label="상품 상태 필터">
        {(['전체', '대기', '판매', '판매노출', '품절'] as const).map(status => (
          <button key={status} type="button" role="tab" aria-selected={statusFilter === status}
            onClick={() => setStatusFilter(status)}>
            {status === '판매노출' ? '판매 노출' : status}<span>{itemlist.filter(item => matchesStatusFilter(item, status)).length}</span>
          </button>
        ))}
      </StatusTabs><CouponActions aria-label="쿠폰 관리">{canManage && <LiveDiscountCoupon key={seq} liveSeq={Number(seq)} products={originList} disabled={!canRegister || saving} />}{cancelCouponTarget && <div ref={cancelCouponTarget} />}</CouponActions></StatusFilterRow>
      {actionNotice && createPortal(<ActionFeedback as={LiveFeedback} fallbackAs="div" key={actionNotice.id} role="status" aria-live="polite">{actionNotice.message}</ActionFeedback>, document.body)}
      {importMessage && <ImportFeedback as={LiveFeedback} role="status">{importMessage}</ImportFeedback>}
      <BulkStatusBar>
        {canManage && <BulkSelectControl>
          <input ref={selectAllRef} type="checkbox" aria-label="현재 목록 전체 선택" checked={allDisplayedSelected}
            disabled={saving || listLoading || Boolean(listError) || selectableDisplayList.length === 0} onChange={toggleAllDisplayed} />
          <span>전체 선택</span>
        </BulkSelectControl>}
        {canManage && <SelectionSummary role="status"><strong>{selectedIds.length}</strong>개 선택</SelectionSummary>}
        <SearchArea data-admin-search="">
          <InputBox
            className="search"
            aria-label="상품명 검색"
            placeholder="상품명을 검색해주세요."
            value={searchWord}
            onChange={setting_searchword}
            onKeyPress={keyPress_keyword}
          />
          <SearchButton data-admin-search-action="" type="button" onClick={() => search_productList(false)}>검색</SearchButton>
          <ResetButton data-admin-search-reset="" type="button" aria-label="상품 검색 초기화" onClick={() => search_productList(true)}>
            <Icon aria-hidden="true" src={require("../../../../Image/ic_reset_black.png")} />
          </ResetButton>
        </SearchArea>
        {canManage && <BulkStatusActions>
          {buttonChoices ? <LiveChoiceButtons label="선택 상품 상태" value="" hideLabel
            disabled={saving || listLoading || Boolean(listError) || selectedIds.length === 0}
            onChange={value => void updateStatuses(selectedIds, value)}
            options={[{ value: '판매', label: '판매' }, { value: '대기', label: '대기' },
              ...(compact ? [{ value: '판매노출', label: '판매노출', disabled: selectedIds.length > 1 }] : [])]} />
            : <SelectBox aria-label="선택 상품 상태" value={bulkStatus} disabled={saving} onChange={e => setBulkStatus(e.target.value)}>
              <option value="판매">판매</option><option value="대기">대기</option>
              {compact && <option value="판매노출" disabled={selectedIds.length > 1}>판매노출</option>}
            </SelectBox>}
          {!buttonChoices && <button type="button" disabled={saving || listLoading || Boolean(listError) || selectedIds.length === 0 || (compact && bulkStatus.startsWith('판매노출') && selectedIds.length > 1)}
            onClick={() => updateStatuses(selectedIds, bulkStatus)}><LiveToolbarIcon name="tools" />{saving ? '변경 중...' : '상태변경'}</button>}
          <button type="button" disabled={saving || printingQr || listLoading || Boolean(listError) || selectedProducts.length === 0}
            onClick={() => void printSelectedQr()}>{printingQr ? 'QR 준비 중...' : 'QR 인쇄'}</button>
          <button type="button" className="delete" aria-describedby={deleteBlockedReason ? deleteHelpId : undefined}
            disabled={saving || listLoading || Boolean(listError) || selectedProducts.length === 0 || Boolean(deleteBlockedReason)}
            onClick={() => void deleteSelectedProducts()}><LiveToolbarIcon name="delete" />삭제</button>
        </BulkStatusActions>}
        {canManage && deleteBlockedReason && <DeleteHelp as={LiveFeedback} id={deleteHelpId} role="status">{deleteBlockedReason}</DeleteHelp>}
      </BulkStatusBar>
      {saveError && <LiveFeedback role="alert">{saveError}{canManage && saveError.includes('영상에 상품 노출') && <button type="button" disabled={saving} onClick={() => void retryVideoExposure()}>영상 노출 재전송</button>}</LiveFeedback>}

      {canManage && itemlist.some(optionStructureLocked) && <LiveFeedback role="status">{inventoryLockMessage}</LiveFeedback>}

      <TableScroll>
      <TableContent $compact={compact} onMouseMove={moveRowDrag} onMouseUp={endRowDrag} onMouseLeave={compact ? undefined : finishDrag}
        onPointerMove={compact ? moveRowDrag : undefined} onPointerUp={compact ? endRowDrag : undefined} onPointerCancel={compact ? finishDrag : undefined}>
      {compact ? <CompactHeader><span aria-hidden="true" /><span>이미지</span><span>상품명</span><span>가격</span><span>남은 재고</span><span>상태</span><span>액션</span></CompactHeader> : <>      <TableHear>
        <div className="select">선택</div>
        <div className="code">상품코드</div>
        <div className="name">상품명</div>
        <div className="img">이미지</div>
        <div className="price">가격</div>
        {paymentMode === 'combined' && <div className="pg-payment">PG</div>}
        <div className="stock">총 재고</div>
        <div className="occupied">점유 재고</div>
        <div className="rest">남은 재고</div>
        <div className="opt-check">옵션 사용여부</div>
        <div className="opt">옵션</div>
        <div className="desc">상품설명</div>
        <div className="status">상품노출</div>
      </TableHear>

</>}

      {listLoading ? (
        <Nonedata role="status">상품 목록을 불러오는 중입니다.</Nonedata>
      ) : listError ? (
        <Nonedata as={LiveFeedback} fallbackAs="div" role="alert">{listError} <button type="button" onClick={() => load_productList()}>다시 시도</button></Nonedata>
      ) : originList.length === 0 ? (
        <Nonedata>등록된 상품이 없습니다.</Nonedata>
      ) : (
        displayList.length === 0 && <Nonedata>{searchWord ? "검색한 상품을 찾을 수 없습니다." : `${statusFilter} 상태의 상품이 없습니다.`}</Nonedata>
      )}

      {!listLoading && displayList.map((data) => {
        const savedProduct = originList.find(product => product.seq === data.seq) ?? data;
        const occupiedStock = Math.max(0, Number(savedProduct.init_cnt) - Number(data.current_cnt));
        const option1 = data.unique_option1?.join(",");
        const option2 = data.unique_option2?.join(",");

        return (
          <React.Fragment key={data.seq}>
          {dropTargetSeq === data.seq && dropPlacement === 'before' && <DropGap data-product-seq={data.seq} data-drop-placement="before" role="status">여기에 {itemlist.find(item => item.seq === draggedSeq)?.name} 넣기</DropGap>}
          <TableRow data-testid={`product-row-${data.seq}`} data-product-seq={data.seq}
            $dropTarget={dropTargetSeq === data.seq} $dragging={draggedSeq === data.seq}
            $compact={compact} $selected={compact && selectedIds.includes(data.seq)}
            onClick={event => {
              if (!compact || !canManage || savingRef.current || event.defaultPrevented
                || (event.target as Element).closest('input, button, select, textarea, a, [role="button"], [data-product-menu]')) return;
              setSelectedIds(ids => ids.includes(data.seq) ? ids.filter(id => id !== data.seq) : [...ids, data.seq]);
            }}
            aria-label={compact ? `${data.name} 상품` : `${data.name} 상품 순서 드래그`}
            onMouseDown={compact ? undefined : event => startRowDrag(event, data.seq)}
            onKeyDown={event => {
              if (compact) return;
              const offset = event.key === 'ArrowUp' ? -1 : event.key === 'ArrowDown' ? 1 : 0;
              if (!offset || (event.target as HTMLElement).closest('input, button, select, textarea')) return;
              event.preventDefault();
              const target = displayList[displayList.findIndex(item => item.seq === data.seq) + offset];
              if (target) void reorderProduct(data.seq, target.seq, offset < 0 ? 'before' : 'after');
            }}
            tabIndex={!compact && canManage && !searchWord && statusFilter === '전체' ? 0 : undefined}
            >
            {compact ? <>
              <div className="select">{canManage && <input type="checkbox" aria-label={`${data.name} 선택`} checked={selectedIds.includes(data.seq)} disabled={saving}
                  onChange={() => setSelectedIds(ids => ids.includes(data.seq) ? ids.filter(id => id !== data.seq) : [...ids, data.seq])} />}</div>
              <div className="img"><CompactImageButton type="button" aria-label={`${data.name} 이미지 ${data.product_img ? '수정' : '추가'}`} disabled={!canManage || saving}
                onClick={() => void openImgModal(data.seq, data.product_imgs, data.product_img)}>
                {data.product_img ? <img src={mediaUrl(data.product_img)} alt={`${data.name} 이미지`} /> : <span aria-hidden="true">+</span>}
              </CompactImageButton></div>
              <div className="name"><ProductNameRow>
                {canManage && <ProductDragHandle type="button" aria-label={`${data.name} 순서 이동`} title="드래그로 순서 변경 · Alt+↑/↓로 이동"
                  disabled={saving || listLoading || Boolean(listError) || Boolean(searchWord) || statusFilter !== '전체'}
                  onPointerDown={event => { startRowDrag(event, data.seq, true); if (rowDragRef.current) event.currentTarget.setPointerCapture?.(event.pointerId); }}
                  onLostPointerCapture={finishDrag} onKeyDown={event => {
                    if (!event.altKey || !['ArrowUp', 'ArrowDown'].includes(event.key)) return;
                    event.preventDefault(); const offset = event.key === 'ArrowUp' ? -1 : 1;
                    const target = displayList[displayList.findIndex(item => item.seq === data.seq) + offset];
                    if (target) void reorderProduct(data.seq, target.seq, offset < 0 ? 'before' : 'after');
                  }}>
                  <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><circle cx="8" cy="5" r="1.5" /><circle cx="16" cy="5" r="1.5" /><circle cx="8" cy="12" r="1.5" /><circle cx="16" cy="12" r="1.5" /><circle cx="8" cy="19" r="1.5" /><circle cx="16" cy="19" r="1.5" /></svg>
                </ProductDragHandle>}
                <InlineProductValue label={`${data.name} 상품명`} value={data.name} disabled={!canManage || saving || data.product_status !== '대기'}
                  onSave={value => saveCompactValue(data.seq, 'name', value)} />
              </ProductNameRow>{data.per_customer_quantity_limit != null && <QuantityLimitLabel>1인당 {data.per_customer_quantity_limit}개</QuantityLimitLabel>}</div>
              <div className="price" title={priceEditLocked(data) ? priceLockMessage : undefined}><InlineProductValue label={`${data.name} 가격`} value={data.price} numeric suffix="원" editLabel="금액 변경" disabled={!canManage || saving || priceEditLocked(data)}
                onSave={value => saveCompactValue(data.seq, 'price', value)} />
                {paymentMode === 'combined' && <PaymentSetting type="button" aria-label={`${data.name} PG 결제`} aria-pressed={data.is_pg !== false} disabled={!canManage || saving}
                  onClick={event => { event.stopPropagation(); void savePaymentMethod(data, data.is_pg === false); }}>{data.is_pg !== false ? 'PG' : '무통장'}</PaymentSetting>}
              </div>
              <div className="rest"><InlineProductValue label={`${data.name} 남은 재고`} value={String(data.current_cnt)} numeric suffix="개" disabled={!canManage || saving}
                onEdit={hasRegisteredOptions(data) ? () => openOptionBox(true, data.seq, data.product_status, data.live_seq, store_info, data.current_cnt, true) : undefined}
                onSave={value => saveCompactValue(data.seq, 'stock', value)} />
              </div>
              <div className="status"><CompactStatusActions>
                <CompactStatusSelect $exposed={hasProductExposure(data)} aria-label={`${data.name} 상태`} value={getProductSaleStatus(data.product_status)}
                    disabled={!canManage || saving} onChange={event => setting_product_status(event, data.seq)}>
                    <option value="대기">대기</option><option value="판매">판매</option>
                    {isSoldOut(data) && <option value="품절">품절</option>}
                  </CompactStatusSelect>
                <ExposeProductButton type="button" aria-label={`${data.name} 판매노출`} aria-pressed={hasProductExposure(data)}
                  disabled={!canManage || saving}
                  title={hasProductExposure(data) ? '판매 노출 OFF · 팝업 내리기' : '판매 노출 ON · 팝업 표시'}
                  onClick={() => { void updateStatuses([data.seq], hasProductExposure(data)
                    ? getProductSaleStatus(data.product_status)! : '판매노출', hasProductExposure(data)); }}>
                  판매노출
                </ExposeProductButton>
                <ProductStateIcon type="button" aria-label={`${data.name} 금액 표시`} aria-pressed={isPriceVisible(data)}
                  disabled={!canManage || saving || !hasProductExposure(data)}
                  title={!hasProductExposure(data) ? '금액 비노출 · 판매노출 후 변경 가능' : isPriceVisible(data) ? '금액 노출 중 · 누르면 숨김' : '금액 비노출 · 누르면 표시'}
                  onClick={() => void updateStatuses([data.seq], `${data.product_status}:${isPriceVisible(data) ? 'seller' : 'visible'}`)}>
                  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" /><circle cx="12" cy="12" r="3" />{!isPriceVisible(data) && <path d="m3 3 18 18" />}</svg>
                  <span>금액</span>
                </ProductStateIcon>
                <ProductStateIcon $soldOut type="button" aria-label={`${data.name} 품절 처리`} aria-pressed={isSoldOut(data)}
                  disabled={!canManage || saving} title={isSoldOut(data) ? '품절 해제 · 이전 상태로 복원' : '품절 처리'}
                  onClick={() => isSoldOut(data) ? void restoreSoldOut(data.seq) : void updateStatuses([data.seq], '품절')}>
                  <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="m6 6 12 12" /></svg>
                  <span>품절</span>
                </ProductStateIcon>
              </CompactStatusActions></div>
              <div className="actions">{canManage && <ProductMenu data-product-menu>
                  <button type="button" aria-label={`${data.name} 설정`} aria-expanded={menuSeq === data.seq} aria-haspopup="menu" disabled={saving}
                    onClick={event => { menuAnchor.current = event.currentTarget; setMenuSeq(current => current === data.seq ? null : data.seq); }}>⋮</button>
                  {menuSeq === data.seq && menuAnchor.current && <ProductActionsMenu anchor={menuAnchor.current} label={`${data.name} 설정 메뉴`}>
                    <button type="button" role="menuitem" aria-expanded={detailSeq === data.seq} aria-controls={`product-details-${data.seq}`} onClick={() => { setMenuSeq(null); setDetailSeq(data.seq); }}>상세 수정</button>
                    <button type="button" role="menuitem" disabled={optionStructureLocked(data) && !hasRegisteredOptions(data)} onClick={() => { setMenuSeq(null); openOptionBox(data.option_check === 'y', data.seq, data.product_status, data.live_seq, store_info, data.current_cnt); }}>옵션 수정</button>
                    <button type="button" role="menuitem" onClick={() => { setMenuSeq(null); void openImgModal(data.seq, data.product_imgs, data.product_img); }}>이미지 수정</button>
                    <button type="button" role="menuitem" disabled={saving || !canCancelProduct} title={canCancelProduct ? undefined : '방송 중에만 상품 전체 취소를 사용할 수 있습니다.'} onClick={() => { setMenuSeq(null); setSaveError(''); setCancelReason(''); setCancelRequestId(crypto.randomUUID()); setCancelTarget(data); }}>상품 전체 취소</button>
                  </ProductActionsMenu>}
                </ProductMenu>}
              </div>
            </> : <>            <div className="select"><input type="checkbox" aria-label={`${data.name} 선택`} checked={selectedIds.includes(data.seq)} disabled={!canManage || saving}
              onChange={() => setSelectedIds(previous => previous.includes(data.seq) ? previous.filter(id => id !== data.seq) : [...previous, data.seq])} /></div>
            <div className="code">
              <InputBox type="text" aria-label={`${data.name} 상품코드`} maxLength={255}
                value={data.product_num ?? data.product_code ?? ''}
                disabled={!canManage || saving}
                onChange={event => setting_product_code(event, data.seq)}
                onBlur={() => void product_update()} />
            </div>
            <div className="name">
              <ProductNameRow>
                <ProductNameInput aria-label={`${data.name} 상품명`} title="더블클릭·드래그로 텍스트 선택" maxLength={255} value={data.name}
                  disabled={!canManage || saving || data.product_status !== '대기'} onChange={event => setting_product_name(event, data.seq)}
                  onBlur={() => void product_update()} />
                <CopyNameButton type="button" aria-label={`${data.name} 상품명 복사`} title="상품명 복사"
                  onClick={() => void copyProductName(data.name)}>
                  <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M8 7V5a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2M5 8h9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2Z"/></svg>
                </CopyNameButton>
              </ProductNameRow>
            </div>
            <div className="img">
              {data.product_img ? (
                <ProductThumb alt={`${data.name} 이미지`} src={data.product_img} onClick={canManage ? () => openImgModal(data.seq, data.product_imgs, data.product_img) : undefined} style={{ cursor: canManage ? "pointer" : "default" }} />
              ) : (
                <EmptyImgBox role={canManage ? "button" : undefined} aria-label={`${data.name} 이미지 추가`} onClick={canManage ? () => openImgModal(data.seq, [], "") : undefined}>
                  <Icon src={require("../../../../Image/ic_plus_gray.png")} style={{ width: "1.6rem", height: "1.6rem" }} />
                </EmptyImgBox>
              )}
            </div>
            <div className="price">
              <InputBox
                type={"number"}
                value={data.price}
                aria-label={`${data.name} 가격`}
                disabled={!canManage || saving || priceEditLocked(data)}
                title={priceEditLocked(data) ? priceLockMessage : undefined}
                onChange={(e: any) => setting_price(e, data.seq)}
                onBlur={() => void product_update()}
              />
            </div>
            {paymentMode === 'combined' && <PaymentSetting type="button" className="pg-payment" aria-label={`${data.name} PG 결제`} aria-pressed={data.is_pg !== false} disabled={!canManage || saving}
              onClick={() => void savePaymentMethod(data, data.is_pg === false)}>{data.is_pg !== false ? 'PG' : '무통장'}</PaymentSetting>}
            <div className="stock">
              <InputBox
                type={"number"}
                value={data.init_cnt}
                disabled={
                  !canManage || saving || hasRegisteredOptions(data)
                }
                aria-label={`${data.name} 총 재고`}
                onChange={(e: any) => setting_init_cnt(e, data.seq)}
                onBlur={() => void product_update()}
              />
            </div>
            <div className="occupied" aria-label={`${data.name} 점유 재고`}>{occupiedStock.toLocaleString()}</div>
            <div className="rest" aria-label={`${data.name} 남은 재고`}>{Number(data.current_cnt).toLocaleString()}</div>
            <div className="opt-check">
              {data.option_check === "n" ? (
                <YesorNo
                  aria-label={`${data.name} 옵션 설정`}
                  onClick={canManage ? () =>
                    openOptionBox(
                      false,
                      data.seq,
                      data.product_status,
                      data.live_seq,
                      store_info,
                      data.current_cnt
                    )
                  : undefined}
                >
                  N
                </YesorNo>
              ) : (
                <YesorNo
                  className="yes"
                  aria-label={`${data.name} 옵션 설정`}
                  onClick={canManage ? () =>
                    openOptionBox(
                      true,
                      data.seq,
                      data.product_status,
                      data.live_seq,
                      store_info,
                      data.current_cnt
                    )
                  : undefined}
                >
                  Y
                </YesorNo>
              )}
            </div>
            <div className="opt">
              {data.option_check === "n" ? (
                "-"
              ) : (
                <div>
                  옵션1 : {option1}
                  <br />
                  옵션2 : {option2}
                </div>
              )}
            </div>
            <div className="desc">
              {data.description ? (
                canManage ? <EditDescBtn onClick={() => openDescModal(data.seq, data.description || "")}>수정하기</EditDescBtn> : <span>{data.description}</span>
              ) : (
                canManage ? <WriteDescBtn onClick={() => openDescModal(data.seq, "")}>작성하기</WriteDescBtn> : <span>-</span>
              )}
            </div>
            <div className="status" title={Number(data.current_cnt) <= 0 ? "재고가 없습니다." : undefined}>
              <SelectBox
                aria-label={`${data.name} 상태`}
                disabled={!canManage || saving}
                className={
                  getProductSaleStatus(data.product_status) === "대기"
                    ? "gray"
                    : hasProductExposure(data)
                      ? "red"
                      : ""
                }
                value={getProductSaleStatus(data.product_status)}
                onChange={(e: any) => setting_product_status(e, data.seq)}
              >
                <option value={"대기"}>대기</option>
                <option value={"판매"}>판매</option>
                <option value="품절">품절</option>
              </SelectBox>
              <ExposeProductButton type="button" aria-label={`${data.name} 판매노출`} aria-pressed={hasProductExposure(data)} disabled={!canManage || saving}
                onClick={() => void updateStatuses([data.seq], hasProductExposure(data) ? getProductSaleStatus(data.product_status)! : '판매노출', hasProductExposure(data))}>판매노출</ExposeProductButton>
            </div>
</>}
          </TableRow>

          {dropTargetSeq === data.seq && dropPlacement === 'after' && <DropGap data-product-seq={data.seq} data-drop-placement="after" role="status">여기에 {itemlist.find(item => item.seq === draggedSeq)?.name} 넣기</DropGap>}
          </React.Fragment>
        );
      })}
      </TableContent>
      </TableScroll>
      {draggedSeq !== null && dragPointer && <DragPreview aria-hidden="true" style={{ left: dragPointer.x + 16, top: dragPointer.y + 16 }}>
        {itemlist.find(item => item.seq === draggedSeq)?.name}
      </DragPreview>}

      <AdminCancellationDialog open={!!cancelTarget} title="상품 전체 취소" reason={cancelReason} onReasonChange={setCancelReason}
        description={cancelTarget ? `“${cancelTarget.name}”의 모든 구매자 주문을 취소합니다. 결제한 품목은 결제수단에 따라 환불 처리됩니다.` : undefined}
        busy={saving} error={saveError} onClose={() => setCancelTarget(null)} onConfirm={() => { if (cancelTarget) void cancelProductOrders(cancelTarget); }} />
      <OptionBox ref={optionRef} bulkStockControls={compact} updateChnage={() => { updateChnage(); showActionNotice(); }} />

      {compact && detailSeq != null && itemlist.some(item => item.seq === detailSeq) && <LiveDetailDialog open title={`${itemlist.find(item => item.seq === detailSeq)!.name} 상품 상세 수정`} size="large" closeOnlyByButton={saving} onClose={() => { if (!savingRef.current) setDetailSeq(null); }}>
        {productDetails(itemlist.find(item => item.seq === detailSeq)!)}
      </LiveDetailDialog>}
      <LiveDetailDialog open={compact && salesManagementOpen} onClose={() => setSalesManagementOpen(false)} title="판매 관리" size="large">
        {listLoading ? <p role="status">상품 목록을 불러오는 중입니다.</p>
          : listError ? <LiveFeedback role="alert">{listError} <SecondaryAction type="button" onClick={() => void load_productList(true)}>다시 시도</SecondaryAction></LiveFeedback>
          : <SalesColumns>
            {(['판매노출', '판매'] as const).map(status => {
              const products = itemlist.filter(item => status === '판매노출'
                ? item.exposure_pending || hasProductExposure(item)
                : getProductSaleStatus(item.product_status) === '판매' && !item.exposure_pending);
              const label = status === '판매노출' ? '노출한 상품' : '판매';
              const sellableProducts = products;
              return <SalesColumn key={status} aria-label={`${label} 관리 목록`}>
                <SalesColumnHeading>
                  <h3>{label}<span>{products.length}</span></h3>
                  {status === '판매' && <SalesTransferAllButton type="button" title="판매 전체 해제 후 노출한 상품으로 이동"
                    disabled={!canManage || saving || products.length === 0}
                    onClick={() => void updateStatuses(products.map(product => product.seq), '대기', false, true)}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d="M20 12H4m6-6-6 6 6 6" /></svg>
                    전체 판매 해제
                  </SalesTransferAllButton>}
                  {status === '판매노출' && <SalesTransferAllButton type="button"
                    title='전체 판매로 이동'
                    disabled={!canManage || saving || sellableProducts.length === 0}
                    onClick={() => void updateStatuses(sellableProducts.map(product => product.seq), '판매')}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d="M4 12h16m-6-6 6 6-6 6" /></svg>
                    전체 판매로 이동
                  </SalesTransferAllButton>}
                </SalesColumnHeading>
                <ul>{products.map(product => <li key={product.seq}>
                  {product.product_img && <img src={mediaUrl(product.product_img)} alt="" />}
                  <div><strong>{product.name}</strong><p>{Number(product.price).toLocaleString()}원 · 남은 재고 {Number(product.current_cnt).toLocaleString()}개</p>
                    {status === '판매노출' && <SalesStatus $exposed={hasProductExposure(product)}>{hasProductExposure(product) ? isSoldOut(product) ? '품절' : '판매노출' : '이전 노출'}</SalesStatus>}
                  </div>
                  {status === '판매' && <SalesMoveButton type="button" aria-label={`${product.name} 노출한 상품으로 이동`} title="판매 해제 후 노출한 상품으로 이동"
                    disabled={!canManage || saving} onClick={() => void updateStatuses([product.seq], '대기', false, true)}>−</SalesMoveButton>}
                  {status === '판매노출' && <SalesMoveButton type="button" aria-label={`${product.name} 판매로 이동`} title={Number(product.current_cnt) <= 0 ? '남은 재고가 없습니다.' : '판매로 이동'}
                    disabled={!canManage || saving} onClick={() => void updateStatuses([product.seq], '판매')}>+</SalesMoveButton>}
                </li>)}</ul>
                {products.length === 0 && <p className="empty">{status === '판매노출' ? '노출한 상품이 없습니다.' : '판매 상품이 없습니다.'}</p>}
              </SalesColumn>;
            })}
          </SalesColumns>}
        {saveError && <LiveFeedback role="alert">{saveError}{saveError.includes('영상에 상품 노출') && <SecondaryAction type="button" disabled={saving} onClick={() => void retryVideoExposure()}>영상 노출 재전송</SecondaryAction>}</LiveFeedback>}
      </LiveDetailDialog>

      <LiveDetailDialog
        closeOnlyByButton={registrationBusy}
        open={registrationOpen && canRegister}
        suspended={registrationCaptureOpen}
        onClose={() => { if (!registrationBusy) setRegistrationOpen(false); }}
        title="라이브 상품 등록"
        description="상품 정보와 이미지를 입력하면 현재 라이브 상품 목록에 바로 반영됩니다."
        size="large"
      >
        <DetailItemInsert
          key={seq}
          captureImage={captureImage}
          getLiveVideo={getLiveVideo}
          onCaptureModeChange={setRegistrationCaptureOpen}
          onBusyChange={setRegistrationBusy}
          updateChnage={updateChnage}
          onRegistered={() => { setRegistrationOpen(false); showActionNotice('등록 완료'); }}
        />
      </LiveDetailDialog>

      <LoadWarehouseProductsModal
        visible={loadPastOpen && canRegister}
        onClose={() => setLoadPastOpen(false)}
        liveSeq={Number(seq)}
        currentProducts={originList} currentPaymentMode={paymentMode}
        onImported={warehouseProductsImported}
      />



      {/* 상품설명 작성 모달 */}
      {captureModalOpen && captureImage && <ProductCaptureModal
        key={seq}
        liveSeq={Number(seq)}
        captureImage={captureImage}
        getLiveVideo={getLiveVideo}
        portalTarget={captureTarget}
        onClose={() => onCaptureModalClose?.()}
        onSaved={saved => {
          if (seq !== currentLiveRef.current) return;
          if (saved.sortOrder === 0) {
            const previous = new Set(pendingThumbnails.current.get(saved.productSeq)?.previous);
            previous.add(mediaUrl(drafts.current.itemlist.find(item => item.seq === saved.productSeq)?.product_img || ''));
            previous.add(mediaUrl(drafts.current.originList.find(item => item.seq === saved.productSeq)?.product_img || ''));
            previous.delete(mediaUrl(saved.imgPath));
            pendingThumbnails.current.set(saved.productSeq, { imgPath: saved.imgPath, previous });
            const applyThumbnail = (items: Live_itemList[]) => items.map(item => item.seq === saved.productSeq
              ? { ...item, thumbnail_img: saved.imgPath, product_img: mediaUrl(saved.imgPath), product_imgs: undefined } : item);
            drafts.current = { itemlist: applyThumbnail(drafts.current.itemlist), originList: applyThumbnail(drafts.current.originList) };
            setItemList(drafts.current.itemlist);
            setOriginList(drafts.current.originList);
          }
          showActionNotice();
          const requestedLive = seq;
          setImportMessage('캡처 이미지를 상품 대표사진으로 등록했습니다.');
          void load_productList(true, true).then(() => {
            if (requestedLive !== currentLiveRef.current) return;
            void emitProductExposure();
          });
        }}
      />}
      <ProductDescriptionModal
        visible={descModalOpen}
        onClose={() => setDescModalOpen(false)}
        description={currentDesc}
        onSave={saveProductDesc}
      />

      {/* 상품 이미지 모달 */}
      {imgModalOpen && <ProductImageModal
        visible={imgModalOpen}
        onClose={() => setImgModalOpen(false)}
        images={currentImages}
        captureImage={captureImage}
        onSave={saveProductImages}
      />}
    </>
  );
};

export default Detail_itemList;

const ListHeader = styled.div`
  flex-wrap: wrap;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 12px;

  h2 {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 4px 0 0;
    color: var(--admin-theme-text, #24212d);
    ${fontStyles.Bold}
    font-size: 24px;
    line-height: 1.35;
  }

  @media (max-width: 760px) {
    flex-direction: column;
  }
`;

const HeaderActions = styled.div`
  max-width: 100%;
  button:disabled {
    opacity: .5;
    cursor: not-allowed;
    box-shadow: none;
    filter: none;
  }
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 760px) {
    width: 100%;
    justify-content: flex-start;
  }
`;

const SecondaryAction = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 46px;
  padding: 0 16px;
  border: 1px solid var(--admin-theme-control-border, #ddd8e7);
  border-radius: 10px;
  background: var(--admin-theme-surface, #ffffff);
  color: var(--admin-theme-text, #3a3345);
  ${fontStyles.semiBold}
  font-size: 14px;
  cursor: pointer;

  img { width: 18px; height: 18px; }
  &:hover { border-color: #8464dd; background: var(--admin-theme-raised, #faf8ff); color: var(--admin-theme-link, #5730c4); }
  &:focus-visible { outline: 3px solid var(--admin-theme-focus, #a993ef); outline-offset: 2px; }
`;

const ImportFeedback = styled.p`
  margin: -8px 0 16px;
  color: var(--admin-theme-success, #246b36);
  font-size: 14px;
  line-height: 1.5;
`;

const Eyebrow = styled.div`
  color: var(--admin-theme-link, #6a42d8);
  ${fontStyles.semiBold}
  font-size: 13px;
`;

const CountBadge = styled.span`
  min-width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--admin-theme-accent-soft, #f0ebff);
  color: var(--admin-theme-link, #5730c4);
  font-size: 14px;
  font-variant-numeric: tabular-nums;
`;

const PrimaryAction = styled.button`
  flex: 0 0 auto;
  min-height: 46px;
  padding: 0 20px;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--admin-accent), #4b20c2);
  color: #ffffff;
  ${fontStyles.semiBold}
  font-size: 15px;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(79, 40, 190, 0.2);

  &:hover { filter: brightness(0.97); }
  &:focus-visible { outline: 3px solid var(--admin-theme-focus, #a993ef); outline-offset: 2px; }
`;

const TableScroll = styled.div`
  box-sizing: border-box;
  width: 100%;
  overflow: auto;
  overscroll-behavior-inline: contain;
  border: 1px solid var(--admin-theme-border, #ebe8ef);
  border-radius: 12px;
`;

const TableContent = styled.div<{ $compact?: boolean }>`
  --live-product-columns: 48px 72px minmax(240px, 1fr) 140px 130px calc(var(--control-sm) * 9 + var(--space-4)) 48px;
  .pg-payment { flex: 0 0 100px; display: flex; flex-direction: column; align-items: center; gap: 8px; }
  .pg-payment input { width: 20px; height: 20px; accent-color: var(--admin-accent); cursor: pointer; }
  .pg-payment input:disabled { cursor: not-allowed; }
  .pg-payment span { font-size: 12px; }

  min-width: ${props => props.$compact ? 'calc(678px + var(--control-sm) * 9 + var(--space-4))' : '1140px'};
  .stock, .occupied, .rest { font-variant-numeric: tabular-nums; }
  .occupied, .rest { min-width: 80px; }

  .code, .name { min-width: 0; }
  .name { padding-inline: 16px; }

  .select input[type="checkbox"] {
    width: 24px;
    height: 24px;
    margin: 0;
    accent-color: var(--admin-accent);
    cursor: pointer;
  }

  .select input[type="checkbox"]:focus-visible {
    outline: 2px solid var(--admin-accent);
    outline-offset: 3px;
  }
`;

const CouponActions = styled.div`display: flex; align-items: center; flex-wrap: wrap; gap: var(--space-2); margin-left: auto;` ;
const StatusFilterRow = styled.div`display: flex; align-items: flex-start; flex-wrap: wrap; gap: var(--space-3);` ;
const StatusTabs = styled.div.attrs<{ 'data-admin-tabs'?: string }>({ 'data-admin-tabs': '' })`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 12px;

  button {
    min-height: 44px;
    padding: 0 18px;
    border: 1px solid var(--admin-theme-border, #ddd8e7);
    border-radius: 9px;
    background: var(--admin-theme-surface, #fff);
    color: var(--admin-theme-muted, #6f6878);
    font: inherit;
    font-weight: 700;
    cursor: pointer;
  }
  button[aria-selected="true"] {
    border-color: var(--admin-accent, #7141dc);
    background: var(--admin-theme-accent-soft, #f0ebff);
    color: var(--admin-theme-link, #5730c4);
  }
  button:focus-visible { outline: 3px solid var(--admin-theme-focus, #a993ef); outline-offset: 2px; }
  span { margin-left: 7px; font-variant-numeric: tabular-nums; }
`;

const DropGap = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 62px;
  margin: 4px 10px;
  border: 2px dashed var(--admin-accent);
  border-radius: 8px;
  background: var(--admin-theme-accent-soft, #f3efff);
  color: var(--admin-theme-link, #5730c4);
  font-size: 14px;
  font-weight: 600;
  pointer-events: auto;
`;

const DragPreview = styled.div`
  position: fixed;
  z-index: 1100;
  max-width: 300px;
  padding: 12px 18px;
  overflow: hidden;
  border: 1px solid var(--admin-accent);
  border-radius: 10px;
  background: var(--admin-theme-surface, #fff);
  box-shadow: 0 14px 30px rgba(48, 30, 105, 0.2);
  color: var(--admin-theme-text, #302a38);
  font-size: 14px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
`;

const BulkStatusBar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0 0 12px;
  padding: 12px 16px;
  border: 1px solid var(--admin-theme-border, #dfd4ff);
  border-radius: 12px;
  background: var(--admin-theme-accent-soft, #f8f5ff);
`;

const BulkSelectControl = styled.label.attrs<{ 'data-live-control-label'?: boolean }>({ 'data-live-control-label': true })`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  padding: 0 14px;
  border: 1px solid var(--admin-theme-border, #cdbcf9);
  border-radius: 9px;
  background: var(--admin-theme-surface, #fff);
  color: var(--admin-theme-link, #38246d);
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;

  input {
    width: 26px;
    height: 26px;
    margin: 0;
    accent-color: var(--admin-theme-link, #6f46dc);
    cursor: pointer;
  }
  input:disabled { cursor: not-allowed; }
  input:focus-visible { outline: 3px solid var(--admin-theme-focus, #d9c9ff); outline-offset: 2px; }
`;

const SelectionSummary = styled.div`
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  color: var(--color-text-link);
  font-size: var(--text-caption);
  font-weight: 500;
  white-space: nowrap;

  strong { font-size: inherit; font-weight: 600; font-variant-numeric: tabular-nums; }
`;

const BulkStatusActions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: auto;

  select { width: 110px; min-height: 48px; border-color: var(--admin-theme-border, #d9d0ef); background: var(--admin-theme-surface, #fff); }
  button {
    display: inline-flex; align-items: center; justify-content: center; gap: var(--gap-icon);
    min-height: 48px;
    padding: 0 18px;
    border: 1px solid var(--admin-theme-focus, #6f46dc);
    border-radius: 9px;
    background: #6f46dc;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;
  }
  button.delete { border: 1px solid var(--admin-danger); background: var(--admin-theme-surface, #fff); color: var(--admin-danger); }
  button.delete:hover:not(:disabled) { background: var(--admin-theme-danger-soft, #fff1f0); }
  button:disabled { border-color: var(--admin-theme-muted, #d6cde7); background: var(--admin-theme-raised, #e9e3f3); color: var(--admin-theme-muted, #867c98); cursor: not-allowed; }
  button:focus-visible, select:focus-visible { outline: 3px solid var(--admin-theme-focus, #b7a1f5); outline-offset: 2px; }

  @media (max-width: 700px) {
    width: 100%;
    margin-left: 0;
    button { flex: 1; }
  }
`;

const DeleteHelp = styled.p`
  flex-basis: 100%;
  margin: 0;
  color: var(--admin-danger);
  font-size: 13px;
  line-height: 1.5;
`;

const TitleArea = styled.div`
  margin-bottom: 1rem;
  ${fontStyles.semiBold}
  font-size: 20px;
`;
const SearchButton = styled.button`
  display: inline-flex; align-items: center; justify-content: center;
  padding: 0 var(--space-3); margin: 0;
  border: 1px solid var(--color-brand); border-radius: var(--radius-md);
  background: var(--color-brand); color: var(--color-text-on-brand);
  font-family: var(--font-family-base); font-size: var(--text-caption); font-weight: var(--font-weight-semibold);
  white-space: nowrap; cursor: pointer;
  &:hover { background: var(--color-brand-hover); border-color: var(--color-text-link); }
  &:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
`;
const SearchArea = styled(RowView2)`
  flex: 0 1 calc(var(--control-sm) * 8);
  min-width: min(100%, calc(var(--control-sm) * 6));
  max-width: calc(var(--control-sm) * 8);
  margin-left: 0;
  gap: var(--space-1);

  > button { flex-shrink: 0; min-height: 44px; margin-left: 0; }
  .search { min-width: 0; min-height: 44px; background: var(--admin-theme-surface, #fff); font-size: 14px; }
  @media (max-width: 700px) { max-width: none; margin-left: 0; }
  @media (max-width: 480px) {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 44px;
    .search { grid-column: 1 / -1; }
  }
`;
const ResetButton = styled.button.attrs<{ 'data-live-icon-control'?: boolean }>({ 'data-live-icon-control': true })`
  box-sizing: border-box;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid var(--admin-theme-control-border, #eeeaf2);
  border-radius: 8px;
  background: var(--admin-theme-surface, #ffffff);
  cursor: pointer;
  img { display: block; width: 20px; height: 20px; filter: var(--admin-theme-icon-filter, none); }
  &:hover { border-color: #8d72df; background: var(--admin-theme-accent-soft, #f8f5ff); }
  &:focus-visible { outline: 3px solid var(--admin-theme-focus, #a993ef); outline-offset: 2px; }
`;
const InputBox = styled.input`
  box-sizing: border-box;
  flex: 1;
  width: 100%;
  padding: 0.8rem;
  ${fontStyles.regular}
  font-size: 16px;
  border: 1px solid var(--admin-theme-control-border, #f0f0f0);
  outline: 0;
  border-radius: 8px;
  &:hover,
  &:focus {
    border: 1px solid var(--admin-theme-focus, #454545);
  }
  &::placeholder {
    color: var(--admin-muted);
  }
  &:disabled {
    color: var(--admin-muted);
    &:hover {
      border: 1px solid var(--admin-theme-control-border, #f0f0f0);
    }
  }

  /* Chrome, Safari, Edge, Opera 화살표 제거 */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox 화살표 제거 */
  &[type=number] {
    -moz-appearance: textfield;
  }
`;
const TableHear = styled(RowView)`
  padding: 1rem 0rem;
  margin-top: 0;
  ${fontStyles.medium}
  background-color: var(--admin-theme-raised, #f8f8f8);
  align-items: center;

  div {
    text-align: center;
    box-sizing: border-box;
  }

  .code { flex: 1.8; }
  .select { flex: 0 0 48px; }
  .name { flex: 2.2; }
  .img { flex: 1; display: flex; justify-content: center; }
  .price { flex: 1.5; }
  .stock { flex: 1.2; }
  .occupied, .rest { flex: 1; }
  .opt-check { flex: 1.2; }
  .opt { flex: 2; text-align: center; }
  .desc { flex: 1.4; }
  .status { flex: 1.5; }
`;

const TableRow = styled(RowView)<{ $dropTarget: boolean; $dragging: boolean; $compact?: boolean; $selected?: boolean }>`
  ${props => props.$compact && `
    display: grid !important; grid-template-columns: var(--live-product-columns); cursor: pointer;
    > .select, > .img, > .name, > .price, > .rest, > .status, > .actions { min-width: 0; padding: var(--space-3); }
    > .name { align-items: stretch; }
    > .status { display: flex; align-items: center; gap: var(--space-2); width: auto; }
  `}

  padding: 0.8rem 0rem;
  align-items: center;
  background: ${({ $dropTarget, $selected }) => $dropTarget ? 'var(--admin-theme-accent-soft, #f2edff)' : $selected ? 'var(--color-brand-subtle)' : 'transparent'};
  box-shadow: ${({ $dropTarget }) => $dropTarget ? 'inset 0 0 0 2px var(--admin-accent)' : 'none'};
  transition: background 120ms ease;
  opacity: ${({ $dragging }) => $dragging ? 0.55 : 1};
  user-select: none;
  cursor: grab;
  &:active { cursor: grabbing; }
  &:focus-visible { outline: 2px solid var(--admin-accent); outline-offset: -2px; }
  input, button, select, textarea { cursor: auto; }

  div {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .select { flex: 0 0 48px; }
  .code {
    flex: 1.8;
    font-size: 14px;
    color: var(--admin-ink);
    ${fontStyles.medium}
    word-break: break-all;
  }
  .name {
    flex: 2.2;
    flex-direction: column;
    gap: 6px;
    font-size: 14px;
    color: var(--admin-ink);
    ${fontStyles.medium}
  }
  .img { flex: 1; }
  .price {
    flex: 1.5;
    input {
      max-width: 6.5rem;
      text-align: center;
    }
  }
  .stock {
    flex: 1.2;
    input {
      max-width: 5.5rem;
      text-align: center;
    }
  }
  .occupied {
    flex: 1;
    color: var(--color-text-primary);
    font-size: var(--text-body);
  }
  .rest {
    flex: 1;
    color: var(--admin-danger);
    font-size: 15px;
    ${fontStyles.semiBold}
  }
  .opt-check { flex: 1.2; }
  .opt {
    flex: 2;
    justify-content: center;
    text-align: center;
    font-size: 13px;
    color: var(--admin-theme-text, #454545);
    line-height: 1.4;
  }
  .desc { flex: 1.4; }
  .status { flex: 1.5; }
  ${props => props.$compact && `
    && { padding-block: var(--space-1); cursor: pointer; }
    && > .name, && > .price, && > .rest { padding: var(--space-2) var(--space-3); }
    && .name { align-items: stretch; }
    && > .price { flex-direction:column;align-items:stretch;gap:var(--space-1); }
    .product-tax-status { color:var(--color-text-secondary);font-size:var(--text-caption);white-space:nowrap; }
    && > .price > span { white-space:nowrap; }
    && > .status { padding-right:var(--space-1); }
    && > .actions { padding-inline:var(--space-1); }
    && div { justify-content: flex-start; text-align: left; }
    && .price > div > span, && .rest > div > span { white-space: nowrap; }
    && input[type="checkbox"] { flex: 0 0 20px; width: 20px; height: 20px; }
  `}

`;

const feedbackFade = keyframes`
  0%, 100% { opacity: 0; }
  7%, 93% { opacity: 1; }
`;

const ActionFeedback = styled.div`
  position: fixed;
  z-index: var(--z-toast);
  inset-inline: var(--space-4);
  bottom: calc(var(--space-6) + env(safe-area-inset-bottom));
  width: fit-content;
  margin-inline: auto;
  padding: var(--space-3) var(--space-6);
  border-radius: var(--radius-md);
  background: var(--color-bg-inverse);
  color: var(--color-text-on-inverse);
  box-shadow: var(--shadow-lg);
  font-family: var(--font-family-base);
  font-size: var(--text-body);
  font-weight: 500;
  pointer-events: none;
  animation: ${feedbackFade} 3s var(--ease-standard) both;
  @media (prefers-reduced-motion: reduce) { animation: none; }
`;

const ProductNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
`;

const ProductNameInput = styled.input`
  min-width: 0;
  width: 100%;
  min-height: 40px;
  padding: 6px 8px;
  border: 1px solid transparent;
  border-radius: 7px;
  background: transparent;
  color: var(--admin-theme-text, #24212d);
  font: inherit;
  &:hover:not(:disabled), &:focus { border-color: var(--admin-theme-border, #ddd8e7); background: var(--admin-theme-surface, #fff); }
  &:focus-visible { outline: 3px solid var(--admin-theme-focus, #a993ef); outline-offset: 1px; }
`;

const CopyNameButton = styled.button`
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  padding: 9px;
  border: 1px solid var(--admin-theme-border, #ddd8e7);
  border-radius: 8px;
  background: var(--admin-theme-surface, #fff);
  color: var(--admin-theme-link, #5730c4);
  cursor: pointer;
  svg { display: block; width: 100%; height: 100%; fill: none; stroke: currentColor; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }
  &:hover { background: var(--admin-theme-accent-soft, #f0ebff); }
  &:focus-visible { outline: 3px solid var(--admin-theme-focus, #a993ef); outline-offset: 2px; }
`;

const ProductThumb = styled.img`
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 8px;
  object-fit: cover;
  border: 1px solid var(--admin-theme-border, #f0f0f0);
`;

const EmptyImgBox = styled(CenterView)`
  width: 3.5rem;
  height: 3.5rem;
  border: 1px solid var(--admin-border);
  border-radius: 50%;
  background-color: var(--admin-theme-surface, #FBFBFB);
  cursor: pointer;
  &:hover {
    border: 1px solid var(--admin-theme-focus, #454545);
  }
`;

const WriteDescBtn = styled.div`
  box-sizing: border-box;
  padding: 0.5rem 0.8rem;
  border: 1px solid var(--admin-theme-focus, var(--admin-accent));
  color: var(--admin-theme-link, var(--admin-accent));
  background-color: var(--admin-theme-surface, white);
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  ${fontStyles.medium}
  white-space: nowrap;
  text-align: center;
  &:hover {
    background-color: var(--admin-theme-accent-soft, #f3f0ff);
  }
`;

const EditDescBtn = styled.div`
  box-sizing: border-box;
  padding: 0.5rem 0.8rem;
  border: 1px solid var(--admin-theme-border, #c6c6c6);
  color: var(--admin-muted);
  background-color: var(--admin-theme-surface, white);
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  ${fontStyles.medium}
  white-space: nowrap;
  text-align: center;
  &:hover {
    border: 1px solid var(--admin-muted);
  }
`;

const ModalOverlay = styled(CenterView)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

const ModalContent = styled.div`
  box-sizing: border-box;
  width: 90%;
  max-width: 30rem;
  background-color: var(--admin-theme-surface, white);
  border-radius: 8px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled(RowView)`
  justify-content: space-between;
  font-size: 18px;
  ${fontStyles.Bold}
  color: var(--admin-ink);
  margin-bottom: 1rem;
  align-items: center;
`;

const CloseIcon = styled(Icon)`
  cursor: pointer;
  width: 1.2rem;
  height: 1.2rem;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
`;

const DescriptionTextArea = styled.textarea`
  box-sizing: border-box;
  width: 100%;
  height: 12rem;
  padding: 1rem;
  border: 1px solid var(--admin-theme-border, #f0f0f0);
  border-radius: 8px;
  font-size: 15px;
  resize: none;
  outline: 0;
  ${fontStyles.regular}
  &:hover, &:focus {
    border: 1px solid var(--admin-theme-focus, #454545);
  }
`;

const SaveDescBtn = styled.div`
  padding: 0.6rem 1.5rem;
  background-color: var(--admin-solid, #292433);
  color: white;
  border-radius: 8px;
  cursor: pointer;
  ${fontStyles.semiBold}
  font-size: 15px;
`;
const YesorNo = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.7rem;
  height: 2.7rem;
  ${fontStyles.Bold}
  color: var(--admin-muted);
  font-size: 14px;
  border-radius: 50px;
  background-color: var(--admin-theme-raised, #f8f8f8);
  transition: background-color 0.3s;
  cursor: pointer;
  &.yes {
    color: white;
    background-color: var(--admin-solid, #292433);
  }
  &.locked {
    cursor: not-allowed;
    opacity: 0.55;
  }
`;
const SelectBox = styled.select`
  width: 6rem;
  padding: 0.8rem 0rem;
  font-size: 16px;
  text-align: center;
  border: 1px solid var(--admin-theme-border, #f0f0f0);
  border-radius: 8px;
  outline: 0;
  cursor: pointer;
  &.red {
    color: var(--admin-danger);
    border: 1px solid #ea2922;
    background-color: var(--admin-theme-danger-soft, #ffe9e8);
  }
  &.gray {
    color: var(--admin-muted);
    background-color: var(--admin-theme-raised, #f8f8f8);
  }
`;
const Nonedata = styled(CenterView)`
  height: 10rem;
  color: var(--admin-theme-muted, #858585);
`;

const SendBtn = styled.div`
  cursor: pointer;
  background-color: var(--admin-solid, #292433);
  height: 48px;
  border-radius: 8px;
  width: 136px;
  color: white;
  ${fontStyles.semiBold}
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
`;


const ProductDragHandle = styled.button.attrs<{ 'data-live-icon-control'?: boolean }>({ 'data-live-icon-control': true })`
  display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: var(--control-sm); min-height: var(--control-md);
  padding: 0; border: 0; border-radius: var(--radius-md); background: transparent; color: var(--color-text-secondary); cursor: grab; touch-action: none;
  svg { width: var(--space-4); height: var(--space-4); }
  &:active { cursor: grabbing; }
  &:hover:not(:disabled) { background: var(--color-bg-subtle); color: var(--color-text-primary); }
  &:disabled { color: var(--color-text-disabled); cursor: default; }
  &:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
  @media (pointer: coarse) { width: var(--touch-target); min-height: var(--touch-target); }
`;
const QuantityLimitLabel = styled.small`display: block; margin-top: var(--space-1); color: var(--color-text-secondary); font-size: var(--text-caption);`;
const KeyboardHelp = styled.p`font-size: var(--text-caption); color: var(--color-text-secondary);`;
const CompactStatusActions = styled.div`
  display: flex; align-items: center; flex-wrap: nowrap; gap: var(--space-1); width: 100%;
  > fieldset { flex: 0 0 auto; }
  && .choices { flex-wrap: nowrap; }
  && .choices > button { flex-shrink: 0; white-space: nowrap; }
`;
const ExposeProductButton = styled.button`
  box-sizing: border-box; display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto;
  width: calc(var(--control-sm) * 2 + var(--space-2));
  height: var(--control-sm); min-height: var(--control-sm); min-width: calc(var(--control-sm) * 2 + var(--space-2));
  padding: 0 var(--space-2); border: 1px solid var(--color-border-default); white-space: nowrap;
  border-radius: var(--radius-md); font: inherit; font-size: var(--text-caption); background: var(--color-bg-inverse);
  color: var(--color-text-on-inverse); cursor: pointer;
  &:disabled { background: var(--color-bg-muted); color: var(--color-text-disabled); cursor: default; }
  &[aria-pressed="true"] { background: var(--color-success-subtle); color: var(--color-success); border-color: var(--color-success); }
  &:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
  @media (pointer: coarse) { min-height: var(--touch-target); }
`;
const ProductStateIcon = styled.button<{ $soldOut?: boolean }>`
  box-sizing: border-box; display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; gap: var(--gap-icon);
  min-width: calc(var(--control-sm) * 2 + var(--space-1)); height: var(--control-sm); padding: 0 var(--space-2);
  border: 1px solid var(--color-border-default); border-radius: var(--radius-md); background: var(--color-bg-surface);
  color: var(--color-text-secondary); font: inherit; font-size: var(--text-caption); white-space: nowrap; cursor: pointer;
  svg { flex-shrink: 0; width: var(--space-4); height: var(--space-4); fill: none; stroke: currentColor; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }
  &:hover:not(:disabled) { background: var(--color-bg-subtle); border-color: var(--color-border-strong); }
  &:disabled { background: var(--color-bg-muted); color: var(--color-text-disabled); cursor: default; }
  &&[aria-pressed="true"] {
    background: ${props => props.$soldOut ? 'var(--color-danger-subtle)' : 'var(--color-brand-subtle)'};
    border-color: ${props => props.$soldOut ? 'var(--color-border-danger)' : 'var(--color-text-link)'};
    color: ${props => props.$soldOut ? 'var(--color-danger-strong)' : 'var(--color-text-link)'};
  }
  &:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
  @media (pointer: coarse) { height: var(--touch-target); }
`;
const CompactStatusSelect = styled.select<{ $exposed: boolean }>`
  box-sizing: border-box; flex: 0 0 auto; width: calc(var(--control-sm) * 2 + var(--space-1)); min-width: 0;
  height: var(--control-sm); min-height: var(--control-sm); padding: 0 var(--space-2);
  border: 1px solid ${props => props.$exposed ? 'var(--color-success)' : 'var(--color-border-default)'}; border-radius: var(--radius-md);
  background: ${props => props.$exposed ? 'var(--color-success-subtle)' : 'var(--color-bg-surface)'};
  color: ${props => props.$exposed ? 'var(--color-success)' : 'var(--color-text-primary)'}; font: inherit;
  font-size: var(--text-caption); cursor: pointer;
  @media (pointer: coarse) { height: var(--touch-target); min-height: var(--touch-target); }
  &:disabled { ${props => !props.$exposed && 'color: var(--color-text-disabled); background: var(--color-bg-muted);'} cursor: default; }
  &:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
`;
const CompactHeader = styled.div`
  display: grid; grid-template-columns: var(--live-product-columns); padding: var(--space-3) 0;
  background: var(--color-bg-subtle); color: var(--color-text-secondary); font-size: var(--text-body); font-weight: 600;
  span { padding-inline: var(--space-3); }
`;


const SalesColumns = styled.div`
  display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: var(--space-4);
  @media (max-width: 720px) { grid-template-columns: minmax(0, 1fr); }
`;
const SalesColumn = styled.section`
  min-width: 0; border: 1px solid var(--color-border-default); border-radius: var(--radius-lg); overflow: hidden;
  h3 { display: flex; align-items: center; gap: var(--space-2); margin: 0; font-size: var(--text-h3); }
  h3 span { color: var(--color-text-secondary); font-size: var(--text-body); }
  ul { list-style: none; padding: 0; margin: 0; max-height: 420px; overflow-y: auto; }
  li { display: flex; align-items: center; gap: var(--space-3); padding: var(--space-3); border-top: 1px solid var(--color-border-default); }
  li > div { flex: 1; min-width: 0; }
  img { width: var(--control-lg); height: var(--control-lg); border-radius: var(--radius-md); object-fit: cover; }
  strong { display: block; overflow-wrap: anywhere; font-size: var(--text-body); font-weight: 600; }
  p { margin: var(--space-1) 0 0; color: var(--color-text-secondary); font-size: var(--text-caption); }
  .empty { padding: var(--space-6) var(--space-4); margin: 0; text-align: center; }
`;
const SalesColumnHeading = styled.header`
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: var(--space-2);
  min-height: var(--control-sm); padding: var(--space-3) var(--space-4); background: var(--color-bg-subtle);
`;
const SalesTransferAllButton = styled(SecondaryAction)`
  flex: none; height: var(--control-sm); min-height: var(--control-sm); padding: 0 var(--space-2); gap: var(--gap-icon);
  border: 1px solid var(--color-border-strong); border-radius: var(--radius-md);
  background: var(--color-bg-surface); color: var(--color-text-primary); font-size: var(--text-caption); white-space: nowrap;
  svg { flex: none; width: var(--space-4); height: var(--space-4); }
  &:hover:not(:disabled) { background: var(--color-bg-subtle); border-color: var(--color-brand); color: var(--color-text-link); }
  &:disabled, &:disabled:hover { background: var(--color-bg-muted); color: var(--color-text-disabled); border-color: var(--color-border-default); cursor: default; }
  &:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
  @media (pointer: coarse) { height: var(--touch-target); min-height: var(--touch-target); }
`;
const SalesStatus = styled.span<{ $exposed: boolean }>`
  display: inline-flex; margin-top: var(--space-2); padding: var(--space-1) var(--space-2); border-radius: var(--radius-sm); font-size: var(--text-caption);
  color: ${props => props.$exposed ? 'var(--color-success)' : 'var(--color-text-secondary)'};
  background: ${props => props.$exposed ? 'var(--color-success-subtle)' : 'var(--color-bg-muted)'};
`;
const SalesMoveButton = styled.button.attrs<{ 'data-live-icon-control'?: boolean }>({ 'data-live-icon-control': true })`
  flex: none; width: var(--control-md); height: var(--control-md); border: 1px solid var(--color-border-default); border-radius: var(--radius-md);
  color: var(--color-text-on-brand); background: var(--color-brand); font: inherit; font-size: var(--text-h3); cursor: pointer;
  &:disabled { color: var(--color-text-disabled); background: var(--color-bg-muted); cursor: default; }
  &:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
`;
const ProductDetails = styled.div`
  display: flex; flex-direction: column; gap: var(--space-5);
  label { color: var(--color-text-secondary); font-size: var(--text-body); }
  input, select, textarea { margin: 0; color: var(--color-text-primary); font: inherit; }
  input:not([type="checkbox"]), select { width: 100%; height: var(--control-md); min-height: var(--control-md); box-sizing: border-box; border-radius: var(--radius-md); }
`;
const DetailHeading = styled.header`
  display:flex;align-items:center;justify-content:flex-end;padding-bottom:var(--space-4);border-bottom:1px solid var(--color-border-default);
`;
const DetailActions = styled.div`
  display: flex; flex-wrap: wrap; align-items: center; gap: var(--space-2);
  button { height: var(--control-md); min-height: var(--control-md); padding: 0 var(--space-3); font-size: var(--text-body); border-radius: var(--radius-md); }
`;
const DetailFields = styled.div`
  display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1.4fr) minmax(0,.8fr);align-items:end;gap:var(--space-4);
  >label:not(.payment-choice){display:flex;flex-direction:column;gap:var(--space-2);}
  >.payment-choice{grid-column:1/-1;justify-self:start;}
  @media(max-width:600px){grid-template-columns:minmax(0,1fr);}
`;
const DeliveryDetails = styled.section`
  display:grid;grid-template-columns:auto minmax(0,16rem);align-items:end;justify-content:start;gap:var(--space-4);
  >label{display:flex;flex-direction:column;gap:var(--space-2);min-width:0;}
  @media(max-width:600px){grid-template-columns:minmax(0,1fr);justify-items:start;width:100%;>label{width:100%;}}
`;
const CurrencyInput = styled.div`
  position:relative;min-width:0;width:100%;
  input{padding-right:var(--space-10);font-variant-numeric:tabular-nums;}
  >span{position:absolute;inset-block:0;right:var(--space-3);display:flex;align-items:center;color:var(--color-text-secondary);pointer-events:none;}
`;
const PaymentSetting = styled.button`
  display:inline-flex;align-items:center;justify-content:center;align-self:flex-start;gap:var(--space-2);min-height:var(--control-md);padding:0 var(--space-3);
  border:1px solid var(--color-border-default);border-radius:var(--radius-md);background:var(--color-bg-surface);color:var(--color-text-primary);font:inherit;font-size:var(--text-caption);cursor:pointer;
  &[aria-pressed="true"]{border-color:var(--color-brand);background:var(--color-brand-subtle);color:var(--color-text-link);}
  &:disabled{color:var(--color-text-disabled);background:var(--color-bg-muted);cursor:not-allowed;}
  &:focus-visible{outline:2px solid var(--color-focus-ring);outline-offset:2px;}
`;
const DetailDescription = styled.label`
  display: flex; flex-direction: column; gap: var(--space-2);
  textarea { min-height: 100px; resize: vertical; padding: var(--space-3); border: 1px solid var(--color-border-default); border-radius: var(--radius-md); background: var(--color-bg-surface); }
  textarea:focus { outline: none; border-color: var(--color-brand); box-shadow: var(--shadow-focus); }
`;
const CompactImageButton = styled.button.attrs<{ 'data-live-image-control'?: boolean }>({ 'data-live-image-control': true })`
  display: inline-flex; align-items: center; justify-content: center; width: 48px; height: 48px; flex: 0 0 48px; padding: 0; overflow: hidden;
  border: 1px solid var(--color-border-default); border-radius: var(--radius-md); background: var(--color-bg-subtle); color: var(--color-text-secondary); font-size: var(--text-h2); cursor: pointer;
  img { width: 100%; height: 100%; object-fit: cover; }
  &:focus-visible { outline: none; box-shadow: var(--shadow-focus); }
  &:disabled { cursor: default; }
`;
function InlineProductValue({ label, value, numeric = false, suffix = '', editLabel, disabled, onEdit, onSave }: {
  label: string; value: string | number; numeric?: boolean; suffix?: string; editLabel?: string; disabled: boolean; onEdit?: () => void; onSave: (value: string) => Promise<boolean>;
}) {
  const valueText = String(value ?? '');
  const [editing, setEditing] = useState(false), [draft, setDraft] = useState(valueText);
  const busy = useRef(false), cancelled = useRef(false);
  const commit = async () => { if (disabled || busy.current || cancelled.current) return; busy.current = true;
    try { if (await onSave(draft)) setEditing(false); } finally { busy.current = false; }
  };
  return <InlineValue>
    {editing ? <label className="inline-edit">{editLabel && <span>{editLabel}</span>}<InputBox autoFocus disabled={disabled} type={numeric ? 'number' : 'text'} min={numeric ? 0 : undefined} step={numeric ? 1 : undefined} aria-label={label} value={draft}
      onChange={event => setDraft(event.target.value)} onBlur={() => void commit()}
      onKeyDown={event => { if (event.nativeEvent.isComposing) return; if (event.key === 'Enter') { event.preventDefault(); void commit(); }
        if (event.key === 'Escape') { cancelled.current = true; setEditing(false); } }} /></label>
      : <><span aria-label={label} title="더블클릭·드래그로 텍스트 선택">{numeric ? Number(value).toLocaleString() : value}{suffix}</span><button data-live-icon-control data-option-edit={Boolean(onEdit) || undefined} type="button" aria-label={`${label} 수정`} title={editLabel} disabled={disabled}
        onClick={() => { if (onEdit) { onEdit(); return; } cancelled.current = false; setDraft(valueText); setEditing(true); }}>
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="m15 5 4 4M4 20l4-1 12-12a2.8 2.8 0 0 0-4-4L4 15z" /></svg></button></>}
  </InlineValue>;
}
const InlineValue = styled.div`
  display: flex; align-items: center; gap: var(--space-1); min-width: 0; width: 100%;
  > span { user-select: text; flex: 1; min-width: 0; overflow-wrap: anywhere; color: var(--color-text-primary); font-size: var(--text-body); }
  > button { flex: 0 0 44px; height: 44px; padding: var(--space-2); border: 0; border-radius: var(--radius-md); background: transparent; color: var(--color-text-secondary); cursor: pointer; }
  > .inline-edit { display: flex; flex-direction: column; gap: var(--space-1); flex: 1; min-width: 0; }
  > .inline-edit > span { color: var(--color-text-secondary); font-size: var(--text-caption); }
  > button[data-option-edit="true"] { color: var(--color-text-link); background: var(--color-brand-subtle); }
  > button:disabled { color: var(--color-text-disabled); cursor: default; }
  > button:hover:not(:disabled) { background: var(--color-bg-subtle); } svg { width: 20px; height: 20px; }
`;

const DeliveryChoice = styled.button`
  min-height:var(--control-md);padding:0 var(--space-4);align-self:flex-start;border:1px solid var(--color-border-default);border-radius:var(--radius-md);background:var(--color-bg-surface);color:var(--color-text-primary);font:inherit;cursor:pointer;
  &[aria-pressed="true"]{border-color:var(--color-brand);background:var(--color-brand-subtle);color:var(--color-text-link);}
  &:disabled{background:var(--color-bg-muted);color:var(--color-text-disabled);cursor:default;}
  &:focus-visible{outline:2px solid var(--color-focus-ring);outline-offset:2px;}
`;
function ProductActionsMenu({ anchor, label, children }: { anchor: HTMLButtonElement; label: string; children: React.ReactNode }) {
  const menuRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState<{ left: number; top: number } | null>(null);
  const owner = anchor.ownerDocument;
  useLayoutEffect(() => {
    const menu = menuRef.current, view = owner.defaultView;
    if (!menu || !view) return;
    const updatePosition = () => {
      const rect = anchor.getBoundingClientRect(), { width, height } = menu.getBoundingClientRect();
      const margin = 12, gap = 4;
      const below = view.innerHeight - rect.bottom - margin;
      const openAbove = height + gap > below && rect.top - margin > below;
      setPosition({
        left: Math.max(margin, Math.min(rect.right - width, view.innerWidth - width - margin)),
        top: Math.max(margin, Math.min(openAbove ? rect.top - height - gap : rect.bottom + gap, view.innerHeight - height - margin)),
      });
    };
    updatePosition();
    view.addEventListener('scroll', updatePosition, true);
    view.addEventListener('resize', updatePosition);
    return () => { view.removeEventListener('scroll', updatePosition, true); view.removeEventListener('resize', updatePosition); };
  }, [anchor, owner]);
  return createPortal(<ProductMenuPopover ref={menuRef} data-product-menu role="menu" aria-label={label}
    style={{ left: position?.left ?? 0, top: position?.top ?? 0, visibility: position ? 'visible' : 'hidden' }}>{children}</ProductMenuPopover>, owner.body);
}

const ProductMenu = styled.div`
  position: relative; flex: 0 0 var(--control-sm);
  && > button { display: inline-flex; align-items: center; justify-content: center; padding: 0;
    height: var(--control-sm); width: var(--control-sm); border: 0; border-radius: var(--radius-md);
    background: transparent; color: var(--color-text-secondary); font-size: var(--text-h3); cursor: pointer; }
  @media (pointer: coarse) {
    flex-basis: var(--touch-target);
    && > button { height: var(--touch-target); width: var(--touch-target); }
  }
`;
const ProductMenuPopover = styled.div`
  position: fixed; z-index: var(--z-modal); box-sizing: border-box; width: 140px;
  max-width: calc(100vw - 2 * var(--space-3)); max-height: calc(100dvh - 2 * var(--space-3)); overflow-y: auto;
  display: flex; flex-direction: column; align-items: stretch;
  border: 1px solid var(--color-border-default); border-radius: var(--radius-md); background: var(--color-bg-elevated);
  box-shadow: var(--shadow-md); padding: var(--space-1); font-family: var(--font-family-base); font-size: var(--text-body);
  && > button { flex-shrink: 0; min-height: 44px; border: 0; padding: var(--space-2); background: transparent; color: var(--color-text-primary); text-align: left; font: inherit; cursor: pointer; }
  && > button:hover:not(:disabled) { background: var(--color-bg-subtle); }
  && > button:disabled { color: var(--color-text-disabled); cursor: not-allowed; }
  > [role="separator"] { margin: var(--space-1) 0; border-top: 1px solid var(--color-border-default); }
`;
